// ArChat Layout Fix
// Created: 12-03-2026 17:33:56
// Author: SIVOL® - Aldo Frias - Argentina

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsEn = {
                'login.title': 'Sign In',
                'login.slogan': 'Conversations without borders!',
                'login.username': 'Username',
                'login.password': 'Password',
                'login.submit': 'Sign In',
                'login.loading': 'Loading...',
                'login.autoRegister.title': 'Auto Registration',
                'login.autoRegister.description': 'If you don\'t have an account, enter your username, password and email. It will be created automatically and you will receive a confirmation link by email.',
                'login.forgotPassword': 'Forgot your password?',
                'login.passwordRecovery.title': 'Recover Password',
                'login.passwordRecovery.description': 'Enter your email to receive a recovery link.',
                'login.passwordRecovery.emailLabel': 'Email',
                'login.passwordRecovery.emailPlaceholder': 'Enter your email',
                'login.passwordRecovery.emailHelp': 'A recovery link will be sent to your email',
                'login.passwordRecovery.send': 'Send',
                'login.passwordRecovery.success': 'A recovery link has been sent to your email. Check your inbox.',
                'login.passwordRecovery.successTitle': 'Email sent',
                'login.passwordRecovery.successMessage': 'We\'ve sent you an email with instructions to reset your password.\nPlease check your inbox and spam folder. The link may take a few minutes to arrive.',
                'login.passwordRecovery.devExplanation': 'In development mode the email is not sent to your inbox; it is saved for preview. Use "View email" to see the content and the recovery link.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Development mode: this email was NOT sent to your inbox. Use "View email" to open the generated message and use the link.',
                'login.passwordRecovery.invalidEmail': 'Please enter a valid email address',
                'login.error.invalidPassword': 'Invalid password',
                'auth.require_email': 'Email is required to complete registration. Please enter your email.',
                'auth.invalid_credentials': 'Incorrect username or password.',
                'auth.user_not_found': 'User not found.',
                'auth.user_inactive': 'Your account is deactivated. Contact the administrator.',
                'auth.tenant_mismatch': 'Your account does not belong to this environment. Contact the administrator.',
                'auth.account_blocked': 'Account is inactive. Enter your email to reactivate it.',
                'auth.device_limit_reached': 'Device limit reached. Sign out on another device or upgrade your plan.',
                'auth.login.device_limit.title': 'Session limit reached',
                'auth.login.device_limit.body': 'Your plan allows a limited number of active sessions or devices. To sign in, sign out on another device or close another active session, then try again.',
                'auth.password_incorrect': 'The password is incorrect.',
                'auth.login.password_error_title': 'Incorrect password',
                'auth.login.password_attempts_hint': 'You have 3 chances to enter your password correctly. If you exceed those attempts, you will need to reset your password.',
                'auth.login.password_attempts_exhausted_title': 'Attempt limit reached',
                'auth.login.password_attempts_exhausted_body': 'You have exceeded the 3 allowed attempts. To continue, reset your password using "Forgot your password?".',
                'auth.login.go_to_reset_password': 'Go to reset password',
                'auth.login.password_remaining_two': 'You have 2 attempts left.',
                'auth.login.password_remaining_one': 'You have 1 attempt left.',
                'auth.login.password_attempts_locked_inline': 'You have reached the maximum number of attempts. You must reset your password.',
                'auth.login.clear_password_lock_after_reset': 'I already changed my password (e.g. on another device)',
                'auth.account_inactive_email_mismatch': 'Account is inactive and the email does not match.',
                'auth.captcha_failed': 'CAPTCHA is incorrect. Check your answer.',
                'auth.captcha_expired': 'Your verification expired. A new one has been generated automatically.',
                'auth.captcha_required': 'Please complete the security verification (CAPTCHA).',
                'auth.unauthorized': 'You do not have permission to access.',
                'auth.generic_error': 'An error occurred. Please try again.',
                'auth.signup_disabled': 'New account registration is temporarily disabled in this environment.',
                'auth.method_not_allowed': 'Method not allowed.',
                'auth.invalid_data': 'Invalid data.',
                'auth.credentials_required': 'Username and password are required.',
                'auth.csrf_invalid': 'Your security session expired. Please reload the page and try again.',
                'auth.username_taken': 'That username is already registered. Sign in or choose another.',
                'auth.username_unavailable': 'That username is not available.',
                'auth.nick_no_spaces': 'Username cannot contain spaces.',
                'auth.password_too_short': 'Password must be at least 6 characters.',
                'auth.password_mismatch': 'Passwords do not match.',
                'auth.rate_limit': 'Too many attempts. Wait a moment and try again.',
                'auth.confirm_success': 'Account confirmed successfully. Redirecting to login...',
                'auth.confirm_already_active': 'Your account is already active. You can sign in.',
                'auth.reset_sent': 'If the email is registered, you will receive instructions to reset your password.',
                'auth.reset_user_not_found': 'We couldn\'t find an account associated with that email address. Please check the spelling or create a new account.',
                'auth.reset_token_invalid': 'Invalid or missing link.',
                'auth.reset_token_expired': 'This link has expired. Request a new one from "Forgot your password?".',
                'auth.reset_done': 'Password updated. You can now log in.',
                'auth.reset_fatal': 'Error saving. Please try again later.',
                'resetPassword.page.title': 'New password',
                'resetPassword.page.description': 'Enter your new password (at least 6 characters).',
                'resetPassword.newPassword': 'New password',
                'resetPassword.newPasswordPlaceholder': 'At least 6 characters',
                'resetPassword.submit': 'Reset password',
                'resetPassword.success': 'Password updated. Redirecting to login...',
                'resetPassword.backToLogin': 'Back to login',

                'account.delete.section_title': 'Delete account',
                'account.delete.description': 'Deleting your account will permanently remove all your data, messages, contacts, and settings. This action cannot be undone.',
                'account.delete.button': 'Delete my account',
                'accountDeletion.title': 'Account and data deletion',
                'accountDeletion.description': 'Request deletion of your ArChat account and associated data.',
                'accountDeletion.openRequest': 'Request account and data deletion',
                'account.delete.confirm_title': 'Delete account',
                'account.delete.confirm_message': 'Are you sure you want to delete your account? A confirmation email will be sent to your inbox. Deletion is permanent and irreversible.',
                'account.delete.email_sent_title': 'Email sent',
                'account.delete.email_sent': 'We sent you a confirmation email. Check your inbox and click the link to confirm the deletion.',
                'account.delete.error': 'Could not process the request. Please try again.',
                'account.delete.confirm_page_title': 'Confirm account deletion',
                'account.delete.confirm_page_desc': 'You are about to permanently delete your ArChat account. All your data, messages, contacts, and settings will be removed. This action cannot be undone.',
                'account.delete.confirm_final_button': 'Yes, permanently delete my account',
                'account.delete.cancel_go_back': 'Cancel and go back',
                'account.delete.done_title': 'Account deleted',
                'account.delete.done_message': 'Your account has been successfully deleted. All your data has been removed.',
                'account.delete_token_expired': 'The deletion link has expired or is no longer valid. Please request a new one from your profile.',
                'account.delete_token_invalid': 'Invalid or missing deletion link.',
                'account.delete_email_failed': 'Could not send the confirmation email. Please try again later.',
                'account.delete_error': 'Error processing the deletion. Please try again later.',
                'account.not_found': 'Account not found.',

                'mail.send_failed': 'Could not send recovery email. Check SMTP configuration or try again later.',
                'auth.register_success_email_sent': 'Account created successfully. A confirmation email has been sent. Please check your inbox (and spam folder) and click the link to activate your account.',
                'auth.register_success_email_pending': 'Account created successfully, but there was a problem sending the confirmation email. The activation token is still valid. Contact the administrator or request a new confirmation email.',
                'auth.email_not_verified': 'You must confirm your email to activate your account.',
                'auth.email_not_verified_title': 'Account pending confirmation',
                'auth.email_send_failed': 'We could not send the email. Please try again or change your email.',
                'auth.email_send_failed_title': 'Could not send email',
                'auth.register.email_failed.title': 'Account created',
                'auth.register.email_failed.message': 'Your account was created successfully, but there was a problem sending the confirmation email. Check spam or request a new email.',
                'auth.register.success.title': 'Account created',
                'auth.register.success.message': 'Account created successfully. A confirmation email has been sent. Please check your inbox (and spam folder) and click the link to activate your account.',
                'auth.resend_sent': 'Confirmation email resent.',
                'auth.resend_activation': 'Resend activation email',
                'auth.pending_activation.title': 'Account pending activation',
                'auth.pending_activation.body': 'Your account is not activated yet. Check your inbox and confirm your registration to sign in to ArChat.',
                'auth.pending_activation.back_to_login': 'Back to login',
                'auth.pending_activation.support_prefix': 'Need help? Contact support:',
                'auth.pending_activation.support_email': 'info@archat.com.ar',
                'auth.pending_activation.email_label': 'Email to resend activation',
                'auth.pending_activation.email_placeholder': 'you@email.com',
                'auth.pending_activation.email_required': 'Enter the email you used to register to resend activation.',
                'auth.pending_activation.sent_title': 'Activation email sent',
                'auth.pending_activation.sent_body': 'If the address matches a pending account, we sent a new activation link. Check your inbox and spam or junk folders.',
                'auth.pending_activation.soft_error_title': 'Resend unavailable',
                'auth.pending_activation.soft_error_body': 'We could not process the resend right now. Please try again in a few minutes or contact us at info@archat.com.ar.',
                'auth.pending_activation.resend_again': 'Send again',
                'auth.resend_email': 'Resend email',
                'auth.retry_resend': 'Retry',
                'auth.change_email': 'Change email',
                'auth.ver_email': 'View email',
                'auth.already_verified': 'Account is already verified.',
                'auth.confirm_email_title': 'Confirm email',
                'auth.confirm_email_text': 'The activation link will be sent to:',
                'auth.confirm_email_edit': 'Edit',
                'auth.confirm_email_confirm': 'Confirm',
                'auth.confirm_email_typo_hint': 'Did you mean ***@{suggestion}?',
                'brand.slogan': 'The power of being understood, no matter the language',
                'brand.appName': 'ArChat®',
                'brand.name': 'ArChat®',
                'home.title': 'ArChat®',
                'home.slogan': 'The power of being understood, no matter the language',
                'home.tagline': 'Messaging with automatic translation',
                'home.login': 'Sign In',
                'home.register': 'Create account',
                'home.language': 'Language',
                'terms.title': 'Terms and Conditions',
                'terms.accept': 'Accept and Continue',
                'terms.reject': 'Reject',
                'terms.rejectShort': 'I do not accept',
                'terms.readAndAccept': 'I have read and accept the Terms and Conditions',
                'terms.cancel': 'Cancel',
                'register.pageTitle': 'Create account',
                'register.pageSubtitle': 'Enter your details to create your account.',
                'register.submitLabel': 'Create account',
                'register.confirm_title': 'Confirm account',
                'register.confirm_message': 'You are about to create the account:',
                'register.confirm': 'Confirm',
                'register.creatingAccount': 'Creating your account…',
                'register.login_link': 'Already have an account?',
                'register.password_hint': 'Minimum 6 characters',
                'register.checking': 'Checking…',
                'register.username_taken': 'This username is already in use.',
                'register.available': 'Available',
                'register.emailAlreadyExists': 'This email is already registered.',
                'register.continue': 'Continue',
                'login.demo.title': 'Demo Access',
                'login.demo.credentials': 'User: demo / Password: demo',
                'login.email.placeholder': 'Enter your email to confirm your account',
                'login.email.help': 'A confirmation link will be sent to your email',
                'common.language': 'Language',
                'app.install': 'Install ArChat',
                'app.install_ios_hint': 'To install: Share > Add to Home Screen',
                'common.loading': 'Loading…',
                'common.edit': 'Edit',
                'common.on': 'On',
                'common.off': 'Off',
                'common.back': 'Back',
                'common.backToStart': 'Back to home',
                'common.changeUser': 'Change user',
                'common.refresh': 'Refresh',
                'common.request_id_label': 'Request ID',
                'login.email.invalid': 'Please enter a valid email',
                'system.processing': 'Processing...',
                'captcha.required': 'Please enter the CAPTCHA answer to continue.',
                'captcha.solve': 'Please solve the CAPTCHA correctly',
                'captcha.generateError': 'Could not load CAPTCHA (possible HTTPS, cookie, or session issue). Reload the page or try another browser.',
                'captcha.label': 'Security verification',
                'security.verification_title': 'Security verification',
                'security.captcha_question': 'Verification question',
                'security.enter_answer': 'Enter the answer',
                'captcha.description': 'Please solve the operation to continue.',
                'captcha.incorrect': 'The captcha answer is incorrect.',
                'captcha.placeholder': 'Enter the answer',
                'captcha.questionFormat': 'What is {a} + {b}?',
                'menu.conversations': 'Conversations',
                'menu.contacts': 'Contacts',
                'menu.dashboard': 'Dashboard',
                'menu.admin': 'Administration',
                'menu.profile': 'My Profile',
                'menu.settings': 'Settings',
                'menu.help': 'Help',
                'menu.promotions': 'Promotions',
                'menu.plans': 'Plans',
                'menu.logout': 'Logout',

                // MVP "Mis archivos"
                'menu.files': 'My files',
                'files.title': 'My files',
                'files.filter_all': 'All',
                'files.filter_sent': 'Sent',
                'files.filter_received': 'Received',
                'files.filter_images': 'Images',
                'files.filter_documents': 'Documents',
                'files.col_name': 'Name',
                'files.col_size': 'Size',
                'files.col_date': 'Date',
                'files.col_direction': 'Dir.',
                'files.col_actions': 'Actions',
                'files.sent': '📤 Sent',
                'files.received': '📥 Received',
                'files.download': 'Download',
                'files.delete_for_me': 'Delete for me',
                'files.delete_confirm_title': 'Delete file',
                'files.delete_confirm_message': 'This file will be removed from your account. It will not be deleted for the other person. Continue?',
                'files.empty': 'You have no files.',
                'files.error_loading': 'Error loading files.',
                'files.unavailableForFree': 'My Files is not included in the FREE plan.',
                'files.availableInFoundationAndPro': 'My Files is available on FOUNDATION and PRO plans.',
                'files.filesFeatureRestricted': 'This feature is not available on your current plan.',
                'files.filesLoadError': 'Error loading files.',
                'files.uploadUnavailableForFree': 'Sending files is not available on the FREE plan.',
                'files.uploadAvailableInFoundationAndPro': 'File uploads are available on FOUNDATION and PRO.',
                'files.recipientStorageFull': 'The recipient has no available storage to receive this file.',
                'files.recipientNoAvailableStorage': 'The recipient has no available storage to receive this file.',
                'files.storageQuotaExceeded': 'You have reached your plan storage limit.',
                'files.freeStorageLimit': 'The FREE plan includes 5 MB of storage for files you receive.',
                'files.load_more': 'Load more',
                'navbar.contacts': 'Contacts',
                'navbar.profile': 'My Profile',
                'navbar.settings': 'Settings',
                'navbar.logout': 'Logout',
                'navbar.status': 'Status',
                'navbar.users': 'Users',
                'navbar.no_blocked_users': 'No blocked users',
                'navbar.blocked_users_title': 'Blocked users',
                'contacts.blocked_users_title': 'Blocked users',
                'contacts.country_label': 'Country',
                'contacts.not_reported': 'Not reported',
                'navbar.user_fallback': 'User {id}',
                'navbar.open_guide': 'Guide',
                'help.view_initial_guide': 'View initial guide',
                'help.how_archat_works': 'How ArChat® works',
                'help.registration': 'Registration',
                'help.private_invitations': 'Private invitations',
                'help.messaging': 'Messaging',
                'help.security': 'Security',
                'contacts.invite_contact': 'Invite contact',
                'contacts.no_contacts': 'No contacts',
                'invitation.quick_button': 'Invite contact',
                'onboarding.title': 'Welcome to ArChat®',
                'onboarding.subtitle': 'Communicate with anyone in any language.',
                'onboarding.step1.label': 'Step 1',
                'onboarding.step1.text': 'Invite your first contact',
                'onboarding.step2.label': 'Step 2',
                'onboarding.step2.text': 'Send your first message',
                'onboarding.actions.invite': 'Invite contact',
                'onboarding.actions.explore': 'Explore ArChat®',
                'onboarding.welcome_title': 'Welcome to ArChat®',
                'onboarding.welcome_subtitle': 'Communicate with anyone in any language.',
                'onboarding.step1': 'Step 1',
                'onboarding.step1_title': 'Step 1',
                'onboarding.step1_description': 'Invite your first contact',
                'onboarding.step2': 'Step 2',
                'onboarding.step2_title': 'Step 2',
                'onboarding.step2_description': 'Send your first message',
                'onboarding.invite_contact': 'Invite contact',
                'onboarding.explore_archat': 'Explore ArChat®',
                'suggestions.title': 'Suggestions',
                'suggestions.form.title': 'Suggestion title',
                'suggestions.form.message': 'Describe your idea',
                'suggestions.form.submit': 'Send suggestion',
                'suggestions.success': 'Thank you for your suggestion. Our team will review it.',
                'suggestions.success.title': 'Thank you for your suggestion!',
                'suggestions.success.reference': 'Reference',
                'suggestions.success.review': 'Our team will review your idea.',
                'suggestions.success.email': 'We have also sent you a confirmation email.',
                'suggestions.success.copy': 'Copy',
                'suggestions.success.copied': 'Reference copied',
                'suggestions.form.required': 'Title and message are required.',
                'suggestions.error': 'Could not send. Please try again.',
                'suggestions.send': 'Send suggestion',
                'suggestions.captcha_placeholder': 'Result',
                'suggestions.cooldown': 'You must wait {minutes} minutes before sending another suggestion.',
                'suggestions.success_title': 'Suggestion sent',
                'suggestions.success_message': 'Your suggestion was sent successfully. Tracking number: {id}',
                'suggestions.sendSuccess': 'Your suggestion was sent successfully.',
                'suggestions.sendError': 'The suggestion could not be sent. Please try again.',
                'suggestions.sent': 'Suggestion sent successfully.',
                'suggestions.new': 'New suggestion',
                'suggestions.empty': 'You have not sent suggestions yet.',
                'suggestions.admin_note': 'Team note',
                'suggestions.status.pending': 'Pending',
                'suggestions.status.reviewed': 'Reviewed',
                'suggestions.status.planned': 'Planned',
                'suggestions.status.implemented': 'Implemented',
                'suggestions.status.rejected': 'Rejected',
                'referral.promo': 'Invite and earn 10,000 characters',
                'referral.stats.sent': 'Sent',
                'referral.stats.accepted': 'Accepted',
                'referral.stats.rewards': 'Rewards',
                'referral.reward.pending': 'Pending',
                'referral.reward.granted': 'Completed',
                'referral.reward.invalid': 'Invalid',
                'referral.reward.in_progress': 'In progress',
                'referral.limit.reached': 'Reward limit reached',
                'referral.waiting.usage': '+10,000 characters each when you and your invitee each send at least one real text message in the same chat (validated server-side).',
                'promotions.title': 'Promotions and rewards',
                'promotions.subtitle': 'Invite contacts and unlock benefits through real usage.',
                'promotions.how_it_works': 'How it works',
                'promotions.step1': 'Invite a contact from your profile.',
                'promotions.step2': 'When they accept and chat with real interaction, it is validated automatically.',
                'promotions.step3': 'The reward is credited and your progress is updated.',
                'promotions.rewards.title': 'Rewards',
                'promotions.reward.invite': 'Reward for each validated referral.',
                'promotions.reward.milestone': 'Bonuses for growth milestones.',
                'promotions.reward.ranking': 'Visibility in the top network builders ranking.',
                'promotions.progress.title': 'Your progress',
                'promotions.progress.sent': 'Sent',
                'promotions.progress.pending': 'You have pending invitations to unlock rewards.',
                'promotions.progress.in_progress': 'Your invitations are in progress: rewards activate after a real conversation.',
                'promotions.progress.remaining': 'You need {count} more conversation to receive your reward.',
                'promotions.progress.sent_count': 'Sent',
                'promotions.progress.pending_count': 'Pending',
                'promotions.progress.in_progress_count': 'In progress',
                'promotions.progress.completed_count': 'Completed',
                'promotions.cta.invite': 'Invite contact',
                'promotions.cta.copy': 'Copy message and link',
                'promotions.cta.copied': 'Message copied',
                'promotions.cta.copy_error': 'Could not copy message',
                'promotions.invite.message': 'I invite you to ArChat — speak in any language. We both gain benefits.',
                'promotions.banner': 'Activate promotions: invite and earn rewards for real usage.',
                'promotions.banner.empty': 'Start now: invite contacts and unlock benefits.',
                'promotions.banner.pending': 'You have pending invitations: complete a real conversation and earn rewards.',
                'promotions.banner.reward': 'You already unlocked rewards! Keep inviting to increase your gains.',
                'promotions.modal.title': 'Promotions program',
                'promotions.modal.body': 'Earn +10,000 characters per referral once a real two-way chat is validated (see program rules).\nInvite today and unlock rewards.',
                'promotions.modal.cta': 'View promotions',
                'errors.suggestionSend': 'Suggestion could not be sent. Please try again.',
                'common.sending': 'Sending...',
                'menu.open': 'Menu',
                'contacts.controls.hide_non_favorites': 'Hide non-favorite contacts',
                'contacts.controls.show_all': 'Show all contacts',
                'common.navigation': 'Navigation',
                'common.favorite': 'Favorite',
                'common.block': 'Block',
                'common.user': 'User',
                'common.avatar': 'Avatar',
                'message.new': 'New message',
                'message.edit': 'Edit message',
                'message.edit.save': 'Save edit',
                'message.edit.cancel': 'Cancel edit',
                'message.translating': 'Translating...',
                'message.translation_failed': 'Could not translate',
                'message.not_translated': 'Original text',
                'message.retry_send': 'Retry',
                'message.status.sending': 'Sending…',
                'message.status.failed': 'Not sent',
                'message.status.sent': 'Sent',
                'message.status.delivered': 'Delivered',
                'message.status.read': 'Read',
                'message.retrying': 'Retrying...',
                'message.delete': 'Delete message',
                'message.deleted_placeholder': 'Message deleted',
                'message.edited': 'Edited',
                'message.edited_at': 'Edited at',
                'message.delete_for_me.tooltip': 'Delete for me',
                'message.delete_for_me.aria': 'Delete this message for me only',
                'message.delete_for_me.confirm_title': 'Delete message',
                'message.delete_for_me.confirm_message': 'This message will be deleted for you and will free this attachment storage from your plan.',
                'message.delete_for_everyone.tooltip': 'Delete for everyone',
                'message.delete_for_everyone.aria': 'Delete this message for all participants',
                'message.delete_for_everyone.confirm_title': 'Delete message for everyone',
                'message.delete_for_everyone.confirm_message': 'This message will be deleted for you and the other participant.',
                'message.delete_for_everyone.window_expired': 'Delete window expired',
                'message.translation.show': 'Show original and translation',
                'message.translation.hide': 'Hide translation',
                'emoji.search': 'Search emoji',
                'emoji.close': 'Close picker',
                'captcha.refresh': 'Regenerate CAPTCHA',
                'presence.unavailable': 'Statuses unavailable',
                'presence.maintenance': 'Server under maintenance',
                'home.access_nav': 'Application access',
                'home.public_nav.pricing': 'Pricing',
                'home.public_nav.aria': 'Main site navigation',
                'home.public_footer.aria': 'Legal links',
                'home.pricing_link': 'Plans & pricing',
                'publicPricing.nav.back_home': '← Home',
                'publicPricing.title': 'Plans and pricing',
                'publicPricing.subtitle': 'Transparent limits aligned with the ArChat subscription engine. Commercial USD prices for international checkout (e.g. Paddle).',
                'publicPricing.commercial_note': 'Functional limits follow PlanConstants / PlanResolver; your tenant may use plan_limits from the database. Checkout uses Paddle (or other officially designated processors) with USD pricing as shown.',
                'publicPricing.plan.free': 'FREE',
                'publicPricing.plan.foundation': 'FOUNDATION',
                'publicPricing.plan.pro': 'PRO',
                'publicPricing.price.free': 'USD 0 / month',
                'publicPricing.price.foundation': 'USD {price} / month',
                'publicPricing.price.pro': 'USD {price} / month',
                'publicPricing.same_limits_pro': 'Same technical limits as PRO (premium contract).',
                'publicPricing.same_limits_foundation': 'Same technical limits as FOUNDATION (premium contract).',
                'publicPricing.badge.foundation': 'Founder program',
                'publicPricing.badge.pro': 'Recommended',
                'publicPricing.free.b1': '30,000 characters per month per account.',
                'publicPricing.free.b2': 'Up to 2 contacts per user; up to 2 active conversations per account.',
                'publicPricing.free.b3': 'No file attachments or storage space; no data export.',
                'publicPricing.free.b4': 'Message history up to 30 days; 1 device per user only.',
                'publicPricing.free.b5': '34 messages/day and 1,000 messages/month (tenant); up to 20 invitations per day.',
                'publicPricing.premium.b1': '300,000 characters per month per account; up to 100 contacts per user.',
                'publicPricing.premium.b2': 'Unlimited conversations and chats (tenant); 1,667 messages/day and 50,000/month.',
                'publicPricing.premium.b3': 'Up to 50 MB storage (tenant); up to 3 devices per user.',
                'publicPricing.premium.b4': 'Unlimited invitations (tenant); export, automatic translation, and files within plan limits.',
                'publicPricing.premium.b5': 'FOUNDATION: same technical contract as PRO, plus Founder program (150 seats). PRO: standard premium.',
                'publicPricing.foundation.founder_note': 'Founder commercial program: limited to {slots} founding seats (see plan summary). Same PRO limits once subscribed.',
                'publicPricing.cta.start_free': 'Create free account',
                'publicPricing.cta.register_paid': 'Create account',
                'publicPricing.paddle_hint': 'Checkout with your chosen payment processor will be completed inside the app when billing is enabled.',
                'publicPricing.legal.nav_label': 'Legal',
                'publicPricing.legal.terms': 'Terms of Service',
                'publicPricing.legal.privacy': 'Privacy Policy',
                'publicPricing.legal.refund': 'Refund Policy',
                'common.requiredFields': 'Please fill in all required fields.',
                'bio.view': 'View bio',
                'bio.modal.original': 'Original',
                'bio.modal.translation': 'Translation',
                'bio.modal.empty': 'This contact has no biography.',
                'bio.modal.translating': 'Translating...',
                'bio.modal.translation_error': 'Could not translate the biography.',
                'attachment.unnamed_file': 'File',
                'auth.login_error.default_title': 'Access error',
                'auth.login_error.default_message': 'Could not sign in.',
                'profile.title': 'My Profile',
                'profile.founderBadge': 'Founder #{position}/{limit}',
                'profile.founderTooltip': 'Founder Member – Lifetime frozen price while subscription remains active',
                'profile.founderMember': 'Founder Member',
                'profile.founderHeaderBadge': '★ Founder #{position}/150',
                'profile.camera.access_denied': 'Could not access the camera. Check permissions.',
                'profile.edit': 'Edit',
                'profile.save': 'Save Changes',
                'profile.save.success': 'Your profile has been updated successfully.',
                'profile.save.success.title': 'Profile Updated',
                'profile.update.success.title': 'Profile Updated',
                'profile.update.success.message': 'Your changes were saved successfully.',
                'profile.save.error': 'Could not update profile. Please try again.',
                'profile.save.error.title': 'Save Error',
                'profile.cancel': 'Cancel',
                'profile.nick': 'Username',
                'profile.nick.help': 'Your unique identifier in the system',
                'profile.nick.readonly': 'Username cannot be modified',
                'profile.nick.readonly.help': 'Username is unique and cannot be modified',
                'profile.email.readonly': 'Email cannot be modified',
                'profile.email.readonly.help': 'Email is unique and cannot be modified',
                'profile.name': 'Real Name',
                'profile.lastname': 'Last Name',
                'profile.alias': 'Alias',
                'profile.email': 'Email',
                'profile.phone': 'Phone',
                'profile.language': 'Language',
                'profile.country': 'Country',
                'profile.country.select': 'Select country',
                'profile.biography': 'Biography',
                'profile.photo': 'Profile Picture',
                'notifications.bell.aria': 'Notifications',
                'notifications.panel.title': 'Notifications',
                'notifications.empty': 'No notifications yet',
                'notifications.mark_read': 'Opens conversation and marks read',
                'profile.notifications.sound': 'Message sound',
                'profile.notifications.sound_desc': 'Play sound when messages or important alerts arrive',
                'profile.security.privacy_note': 'Manage your account privacy and security.',
                'profile.security.sessions_title': 'Active sessions',
                'profile.security.current': 'Current session',
                'profile.invitations.title': 'Invitations',
                'profile.invitations.validated': 'Validated invites',
                'profile.invitations.nextBadge': 'Next badge',
                'profile.invitations.progress': 'Progress',
                'profile.invitations.achievement': 'Achievement',
                'profile.invitations.topInviterAchieved': 'Top Inviter achieved',
                'profile.invitations.badges.networkBuilder': 'Network Builder',
                'profile.invitations.badges.topInviter': 'Top Inviter',
                'profile.invitations.achievement.networkBuilderMessage': 'You invited 20 users to ArChat.',
                'profile.invitations.achievement.topInviterMessage': 'You invited 50 users to ArChat.',
                'profile.plan.expires': 'Expires on',
                'profile.plan.loading_info': 'Loading plan information...',
                'profile.plan.valid_until': 'Valid until:',
                'profile.plan.active_since': 'Active since:',
                'profile.plan.active_badge': '✓ Active',
                'profile.plan.upgrade.button': 'Upgrade to PRO',
                'profile.plan.upgrade.hint': 'More capacity with FOUNDATION or PRO when billing is enabled',
                'profile.manage_plan': 'Manage plan',
                'plan.current_plan': 'Current plan',
                'plan.current': 'Current',
                'plan.footer_prefix': 'Plan:',
                'plan.upgrade_to_pro': 'Upgrade to PRO',
                'plan.upgrade_to_foundation': 'Upgrade to FOUNDATION',
                'plans.upgrade.title': 'Upgrade Plan',
                'plans.upgrade.comparison': 'Plan Comparison',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Cancel anytime',
                'plans.actions.upgrade_pro': 'Upgrade to PRO',
                'plans.actions.become_founder': 'Become a Founder',

                'plans.modal.card.current_badge': 'Your current plan',

                'plans.modal.card.lower_tier': 'Below your active plan',

                'plans.modal.card.manage_in_profile': 'To change or cancel, use Subscription & billing in your profile.',
                'plans.modal.card.cancel_subscription': 'Cancel subscription',
                'plans.modal.cancel_confirm.title': 'Cancel or manage subscription',
                'plans.modal.cancel_confirm.body': 'A new tab will open the secure Paddle billing portal. There you can update your payment method, view invoices, or cancel your subscription.',
                'plans.modal.cancel_confirm.continue_button': 'Continue',
                'plans.modal.cancel_confirm.back_button': 'Back',
                'plans.modal.cancel_paddle_fallback.title': 'Manage your subscription',
                'plans.modal.cancel_paddle_fallback.body': 'The Paddle billing portal isn’t opened from here in this environment—for example, local development or an account not yet linked to billing. You can still review and compare plans on this screen.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Got it',
                'plans.upgrade_required': 'Available on PRO plan',
                'plan.payment_coming': 'Payment with Paddle will be available soon. You will be able to change your plan from here.',
                'plan.payment_coming_title': 'Coming soon',
                'plan.foundation_full': 'FOUNDATION slots are full (150 founders). You can choose PRO.',
                'plan.sold_out': 'Sold out',
                'plan.founder_spots_remaining': 'Only {count} spots left',
                'plan.founders_occupied': 'founders occupied',
                'plan.upgrade_not_allowed': 'Only FREE plan users can request an upgrade.',
                'plan.free_contacts': 'Up to 2 contacts',
                'plan.free_no_files': 'No files',
                'plan.free_retention': '30-day history',
                'plan.free_characters_month': '30,000 characters / month',
                'plan.pro_characters_month': '300,000 characters / month',
                'plan.pro_files': 'Files up to 50MB',
                'plan.pro_export': 'Export',
                'plan.founder_support': 'Priority support',
                'plan.founder_badge': 'Founder badge',
                'billing.change_plan': 'Change plan',
                'billing.usage.title': 'Plan usage',
                'billing.usage.users': 'Users',
                'billing.usage.messages': 'Messages (today)',
                'billing.usage.invitations': 'Invitations (today)',
                'billing.usage.messages_month': 'Messages this month',
                'billing.usage.chats': 'Conversations',
                'billing.usage.contacts': 'Contacts',
                'billing.usage.chars_month': 'Characters per month',
                'billing.usage.storage': 'Storage used',
                'billing.usage.devices': 'Devices connected',
                'billing.usage.warning': 'You are approaching your plan limit. Upgrade to FOUNDATION or PRO for more capacity.',
                'plans.limit.reached': 'Limit reached — Upgrade plan',
                'billing.loading': 'Loading...',
                'billing.view_plans': 'View plans',
                'billing.subscription.section_title': 'Subscription & billing',
                'billing.subscription.provider_note': 'Provider',
                'billing.subscription.paddle_active': 'Paddle (active plan in app)',
                'billing.subscription.mp_action_ok': 'Request recorded. If checkout did not open, check your connection or try again.',
                'billing.paddle.manage_subscription_button': 'Manage subscription',
                'billing.paddle.cancel_via_portal': 'Cancel subscription',
                'billing.paddle.portal_confirm_title': 'Billing portal',
                'billing.paddle.portal_confirm': 'Your secure Paddle portal will open to update payment method, invoices, or cancel the subscription. Continue?',
                'billing.paddle.portal_opened_hint': 'The Paddle portal opened in a new tab. Refresh your profile if the plan did not update.',
                'billing.paddle.portal_error': 'Could not open the Paddle portal. Try again later or contact support.',
                'billing.paddle.test_access_denied_body': 'Billing actions are restricted on this server (test allowlist / sandbox mode). If you already paid with a live account, production must allow billing for all users (e.g. PAYMENTS_ALLOW_ALL_BILLING_USERS) or disable the test restriction. Contact support.',
                'billing.paddle.no_link_error': 'No Paddle subscription link on your account yet. If you just paid, wait for the webhook or contact support.',
                'billing.paddle.api_not_configured': 'The server is missing Paddle API configuration (PADDLE_API_KEY). An administrator must set it.',
                'billing.descriptions.contacts': 'Total contacts stored in your account',
                'billing.descriptions.storage': 'Storage used for files and media',
                'billing.descriptions.chars_month': 'Characters translated this month',
                'billing.descriptions.devices': 'Active devices connected',
                'billing.paddle.return_title': 'Payment received',
                'billing.paddle.return_body': 'If you completed checkout, your plan will update shortly after Paddle confirms payment. You can return to the app home.',
                'billing.paddle.verifying': 'Checking your plan…',
                'billing.paddle.not_logged_in': 'Sign in to see your updated plan status.',
                'billing.paddle.plan_updated': 'Plan updated successfully: {plan}',
                'billing.paddle.plan_current': 'Your current plan: {plan}',
                'billing.paddle.plan_current_founder': 'You are now a Founder — {plan}',
                'billing.paddle.still_free_hint': 'If you still see FREE after a short wait, the webhook may be delayed. Check backend logs or refresh this page.',
                'billing.paddle.pro_extra_hint': 'You can return home to use your plan.',
                'profile.theme.dark': 'Dark Mode',
                'profile.theme.light': 'Light Mode',
                'profile.theme.argentina': 'Argentina Theme',
                'modal.title': 'Title',
                'modal.success.title': 'Success',
                'modal.error.title': 'Error',
                'modal.warning.title': 'Warning',
                'info.title': 'Information',
                'appearance.title': 'Appearance',
                'appearance.theme.light': 'Light',
                'appearance.theme.dark': 'Dark',
                'theme.title': 'Theme',
                'theme.light': 'Light',
                'theme.dark': 'Dark',
                'profile.photo.section': 'Profile Photo',
                'profile.personalInfo': 'Personal Information',
                'profile.preferences': 'Preferences',
                'profile.country.help': 'The time zone will be automatically assigned according to the selected country',
                'profile.lastname.placeholder': 'Your last name (optional)',
                'profile.name.placeholder': 'Your real name (optional)',
                'profile.biography.placeholder': 'Tell us about yourself...',
                'profile.plan.title': 'Subscription Plan',
                'profile.plan.current': 'Current Plan',
                'profile.plan.free.description': 'Free plan with FREE engine limits (aligned with /pricing). You can move to FOUNDATION (Founder) or PRO when billing is enabled.',
                'profile.plan.foundation.description': 'FOUNDATION (Founder): same premium usage as PRO, plus the Founder program and limited seats (150).',
                'profile.plan.pro.description': 'PRO: standard premium access with engine limits (aligned with /pricing).',
                'profile.photo.change': 'Change profile picture',
                'message.placeholder': 'Write a message...',
                'message.placeholderWithFile': 'Send file',
                'message.sent_from_country': 'Sent from',
                'message.sent_at_local_time': "Sender's local time",
                'message.timezone_label': 'Timezone',
                'message.context_info': 'This message preserves the time context of when it was sent.',
                'message.context_pro_hint': 'This message includes sender time and location context in Pro plans.',
                'message.context_pro_badge': 'Pro context',
                'messages.empty': 'No messages yet',
                'messages.loading': 'Loading messages...',
                'messages.connecting_server': 'Connecting to the message server...',
                'messages.pending_send_count': '{count} message(s) waiting to be sent',
                'attachment.title': 'Attach File',
                'attachment.close': 'Close',
                'attachment.gallery': 'Photo/video gallery',
                'attachment.cameraFront': 'Front camera',
                'attachment.cameraBack': 'Back camera',
                'attachment.cameraWeb': 'Web camera',
                'attachment.selectFile': 'Select file (PDF, text, images, videos)',
                'attachment.remove': 'Remove',
                'attachment.audioNotSupported': 'Audio messages are not compatible with ArChat®. Please send a written message.',
                'attachment.storage_insufficient_precheck.title': 'Insufficient storage',
                'attachment.storage_insufficient_precheck.message': 'This file is {fileSizeMb} MB and you only have {availableMb} MB available. Free up space or upgrade your plan to continue.',
                'attachment.files_disabled.title': 'Plan limit',
                'attachment.files_disabled.message': 'Your current plan does not include file uploads. Upgrade your plan to continue.',
                'attachments.recipientFreeBlocked.title': 'Plan limitation',
                'attachments.recipientFreeBlocked.sender': 'This user is on the Free plan and cannot receive file attachments.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} tried to send you a file attachment, but your Free plan cannot receive attachments. We recommend upgrading to a higher plan to receive files.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Upgrade plan',
                'message.audioDeprecated.title': 'Voice message not compatible',
                'message.audioDeprecated.message': 'This voice message is no longer compatible with ArChat®. Please send a written message.',
                'camera.title': 'Camera',
                'camera.close': 'Close',
                'camera.switch': 'Switch camera',
                'camera.capture': 'Take Photo',
                'camera.loading': 'Starting camera...',
                'camera.retry': 'Retry',
                'camera.error.access': 'Could not access camera. Check permissions.',
                'camera.error.permission': 'Camera permissions denied. Please allow camera access in browser settings.',
                'camera.error.notFound': 'No camera found.',
                'camera.error.busy': 'Camera is being used by another application.',
                'camera.error.constraint': 'Camera constraints cannot be satisfied.',
                'profile.photo.take': 'Take photo',
                'profile.photo.gallery': 'Choose from gallery',
                'profile.photo.select': 'Select photo',
                'profile.photo.select.gallery': 'Choose from gallery',
                'profile.photo.uploading': 'Uploading image...',
                'profile.photo.upload.success': 'Profile photo updated successfully',
                'profile.photo.upload.success.title': 'Photo Updated',
                'profile.photo.upload.error': 'Error uploading profile photo. Please try again.',
                'profile.photo.upload.error.title': 'Upload Error',
                'avatar.errors.too_large': 'Image is too large. Maximum size: 2 MB.',
                'avatar.preview.title': 'Preview avatar',
                'profile.avatar.error_title': 'Could not update avatar',
                'profile.avatar.error.title': 'Avatar update failed',
                'profile.avatar.error.size': 'The image is too large. Maximum allowed size is 2 MB.',
                'profile.avatar.tooLarge.title': 'Image too large',
                'profile.avatar.tooLarge.message': 'The photo exceeds the allowed size. Maximum is 2 MB.',
                'profile.avatar.uploadError.title': 'Could not update avatar',
                'profile.avatar.uploadError.message': 'Something went wrong uploading the image. Please try again.',
                'profile.saveSuccess.title': 'Profile updated',
                'profile.saveSuccess.message': 'Your changes have been saved successfully.',
                'profile.avatar.file_too_large': 'The image exceeds the maximum allowed size (2 MB).',
                'profile.avatar.file_too_large_hint': 'Choose a smaller image or compress it and try again.',
                'profile.photo.take.front': 'Front camera',
                'profile.photo.take.back': 'Back camera',
                'profile.photo.take.webcam': 'Webcam',
                'profile.photo.camera.front': 'Front camera',
                'profile.photo.camera.back': 'Back camera',
                'profile.photo.camera.web': 'Web camera',
                'profile.photo.close': 'Close',
                'profile.photo.capture': 'Capture',
                'user.default': 'User',
                'logout.title': 'Confirm',
                'logout.confirm': 'Are you sure you want to log out?',
                'block.toggle_error': 'Could not block or unblock.',
                'contacts.title': 'Contacts',
                'contacts.search': 'Search contact',
                'contacts.search.placeholder': 'Search by username, name, lastname, country or language...',
                'contacts.sort': 'Sort',
                'contacts.sortByName': 'By name',
                'contacts.sortByStatus': 'By status',
                'contacts.sortByRecent': 'Most recent',
                'contacts.filter': 'Filter',
                'contacts.filterAll': 'All',
                'contacts.filterAvailable': 'Available',
                'contacts.filterInvited': 'Invited',
                'contacts.filterBlocked': 'Blocked',
                'contacts.pending_invitations': 'Pending invitations',
                'contacts.status.invitation_sent': 'Invitation sent',
                'contacts.viewContactInfo': 'View contact details',
                'contacts.contactInfoTitle': 'Contact details',
                'contacts.phone': 'Phone',
                'contacts.bio': 'Bio',
                'contacts.notProvided': 'Not provided',
                'contacts.empty': 'No contacts',
                'contacts.empty.title': 'You don\'t have any contacts yet',
                'contacts.empty.message': 'Invite or add one to start chatting.',
                'contacts.empty.invite_button': 'Invite a contact',
                'contacts.empty.private.message': 'Your profile is private. Invite contacts to start chatting.',
                'contacts.empty.private.invite_button': 'Invite a contact',
                'contacts.unread.badge': 'Unread messages',
                'contacts.search.no_results': 'No contacts found',
                'contacts.search.clear': 'Show all',
                'contacts.controls.search_placeholder': 'Search contact...',
                'contacts.controls.search_label': 'Search contact',
                'contacts.controls.sort_label': 'Sort by',
                'contacts.controls.sort.name': 'Name',
                'contacts.controls.sort.status': 'Status',
                'contacts.controls.sort.recent': 'Recent',
                'contacts.controls.sort.manual': 'Manual',
                'contacts.controls.sort.manual_drag_hint': 'Drag to reorder',
                'contacts.controls.filter_label': 'Status',
                'contacts.controls.filter.all': 'All',
                'contacts.controls.filter.available': 'Available',
                'contacts.controls.filter.invited': 'Invited',
                'contacts.controls.filter.blocked': 'Blocked',
                'contacts.controls.filter.favorites': 'Favorites',
                'contacts.nick': 'Username',
                'contacts.name': 'Name',
                'contacts.lastname': 'Last Name',
                'contacts.country': 'Country',
                'contacts.language': 'Language',
                'contacts.status': 'Status',
                'status.available': 'Available',
                'status.busy': 'Busy',
                'status.in_call': 'In call',
                'status.away': 'Away',
                'status.offline': 'Offline',
                'status.custom': 'Custom message',
                'status.set_title': 'Availability status',
                'status.set_button': 'Change status',
                'status.placeholder': 'Optional message (e.g. In a meeting)',
                'contacts.status.pending_registration': 'Pending registration',
                'contacts.status.registered': 'Invited - Registered',
                'contacts.status.ready_to_chat': 'Ready to chat',
                'contacts.status.active_conversation': 'Active conversation',
                'contacts.invitation.pending.title': 'Pending Invitation',
                'contacts.invitation.pending.message': 'This invitation is pending registration. The contact will receive an email to complete their registration. Once registered, you can chat with them.',
                'contacts.error.no_registered': 'The contact is not yet registered. Wait for them to complete their registration.',
                'contact.edit.title': 'Edit Contact',
                'contact.edit.alias.label': 'Custom alias',
                'contact.edit.alias.placeholder': 'E.g: John from work',
                'contact.edit.alias.help': 'This name will appear instead of the real name',
                'contact.edit.nota.label': 'Personal note',
                'contact.edit.nota.placeholder': 'Add a note about this contact...',
                'contact.edit.nota.help': 'Private notes visible only to you',
                'contact.edit.error.noUser': 'Error: User not identified',
                'contact.edit.error.noContactId': 'Error: Could not identify the contact',
                'contact.edit.error.save': 'Error saving',
                'contact.limit.title': 'Contact limit reached',
                'contact.limit.message': 'The FREE plan allows up to 2 contacts per user. Upgrade to FOUNDATION or PRO for more capacity when billing is enabled.',
                'contact.favorite.add': 'Add to favorites',
                'contact.favorite.remove': 'Remove from favorites',
                'contact.block.block': 'Block',
                'contact.block.unblock': 'Unblock',
                'conversation.backToContacts': 'Back to contacts',
                'conversation.notFound': 'Conversation not found',
                'help.title': 'ArChat® Help',
                'help.howWorks.title': '👥 How ArChat® works (real flow)',
                'help.howWorks.step1.title': '1️⃣ Registration',
                'help.howWorks.step1.point1': 'Sign in with your nickname and password.',
                'help.howWorks.step1.point2': 'If you don\'t have an account, it\'s created automatically.',
                'help.howWorks.step1.point3': 'You accept the Terms and Conditions in your language.',
                'help.howWorks.step1.point4': 'You confirm your account by email.',
                'help.howWorks.step2.title': '2️⃣ Private invitations',
                'help.howWorks.step2.point1': 'Invite contacts by email from your profile.',
                'help.howWorks.step2.point2': 'Define the language and conversation mode before starting.',
                'help.howWorks.step2.point3': 'The contact receives a private invitation.',
                'help.howWorks.step2.point4': 'You can see if they are: Pending, Registered, Ready to chat',
                'help.howWorks.step2.point5': 'Contacts are not searched, they are invited.',
                'help.howWorks.step2.point6': 'Contacts are not searched, they are invited.',
                'help.howWorks.step3.title': '3️⃣ Contacts and conversations',
                'help.howWorks.step3.point1': 'Your contacts appear automatically when:',
                'help.howWorks.step3.point2': 'they accept an invitation',
                'help.howWorks.step3.point3': 'or a conversation exists',
                'help.howWorks.step3.point4': 'You can:',
                'help.howWorks.step3.point5': 'mark them as favorites ⭐',
                'help.howWorks.step3.point6': 'assign them custom aliases',
                'help.howWorks.step3.point7': 'add private notes',
                'help.howWorks.step3.point8': 'block or manage them',
                'help.howWorks.step3.point9': 'There is no public directory or visible users without consent.',
                'help.howWorks.step4.title': '4️⃣ Messaging with translation',
                'help.howWorks.step4.point1': 'Always write in your language.',
                'help.howWorks.step4.point2': 'The system automatically translates the message.',
                'help.howWorks.step4.point3': 'The recipient receives it in their language.',
                'help.howWorks.step4.point4': 'You can see the applied translation.',
                'help.howWorks.step4.point5': 'If a translation fails, it is automatically retried.',
                'help.howWorks.step4.point6': 'ArChat® prioritizes clarity and meaning, not just speed.',
                'help.privacy.title': '🔒 Privacy and control',
                'help.privacy.point1': 'Your profile is private by default.',
                'help.privacy.point2': 'Only those you invite can see or write to you.',
                'help.privacy.point3': 'Public visibility is optional and disabled by default.',
                'help.privacy.point4': 'Active security with:',
                'help.privacy.point5': 'CAPTCHA',
                'help.privacy.point6': 'rate limiting',
                'help.privacy.point7': 'fingerprint',
                'help.privacy.point8': 'email verification',
                'help.privacy.point9': 'Your conversations are not public or indexed.',
                'help.files.title': '📎 Files and export',
                'help.files.point1': 'Attach images, videos, and PDF documents.',
                'help.files.point2': 'Capture photos with front, back camera, or webcam.',
                'help.files.point3': 'Images are automatically compressed.',
                'help.files.point4': 'Preview before sending.',
                'help.files.point5': 'Progress bar during upload.',
                'help.files.point6': 'Export complete conversations to:',
                'help.files.point7': 'PDF',
                'help.files.point8': 'HTML',
                'help.files.point9': 'Includes messages, images, and files.',
                'help.files.point10': 'Your data is yours.',
                'help.experience.title': '🎨 User experience',
                'help.experience.point1': 'Presence status and custom statuses with emoji.',
                'help.experience.point2': 'Integrated OpenMoji emojis.',
                'help.experience.point3': 'Read and typing indicators.',
                'help.experience.point4': 'Mobile view optimized same as desktop.',
                'help.experience.point5': 'Installable PWA application.',
                'help.experience.point6': 'Two themes: Argentina (light blue/white/gold) and Dark (deep purple).',
                'help.experience.point7': 'Profile editing without refreshes.',
                'help.experience.point8': 'Country selector with automatic timezone.',
                'help.experience.point9': 'Quick access with favorites, search and filters.',
                'help.languages.title': '🌍 Languages',
                'help.languages.point1': 'Support for {count} languages.',
                'help.languages.point2': 'Visual selector with flags.',
                'help.languages.point3': 'Interface, T&C and emails adapted to the chosen language.',
                'help.languages.point4': 'Automatic bidirectional translation between users.',
                'help.tipsNew.title': '💡 Tips to make the most of ArChat®',
                'help.tipsNew.point1': 'Invite only people you really want to communicate with.',
                'help.tipsNew.point2': 'Use aliases and private notes to organize contacts.',
                'help.tipsNew.point3': 'Mark favorites for quick access.',
                'help.tipsNew.point4': 'Review the translation before sending important messages.',
                'help.tipsNew.point5': 'Export relevant conversations for backup or work.',
                'help.tipsNew.point6': 'Use ArChat® when written clarity is key.',
                'help.whySubscribe.title': '🚀 Why subscribe to ArChat®',
                'help.whySubscribe.point1': 'ArChat® is not designed to chat with anyone,',
                'help.whySubscribe.point2': 'but to communicate better with those who matter.',
                'help.whySubscribe.point3': 'If you need:',
                'help.whySubscribe.point4': 'clarity between languages',
                'help.whySubscribe.point5': 'real privacy',
                'help.whySubscribe.point6': 'contact control',
                'help.whySubscribe.point7': 'conversation export',
                'help.whySubscribe.point8': 'a professional and noise-free experience',
                'help.whySubscribe.point9': 'ArChat® is designed for that.',
                'help.how.step1.description': 'Use your nick and password to access the system. If you don\'t have an account, it will be created automatically.',
                'help.how.step2.title': 'Invite your contact',
                'help.how.step2.description': 'Invite your contact by email from your profile. Define the language and conversation mode from the start.',
                'help.how.step3.title': 'Write in your language',
                'help.how.step3.description': 'Write your message in your preferred language. The system will automatically translate the written message.',
                'help.how.step4.title': 'The other receives translated',
                'help.how.step4.description': 'The recipient receives the message automatically translated to their language, maintaining clarity and context.',
                'help.features.title': 'Main features',
                'help.features.translation': '🌐 Automatic and instant translation between languages',
                'help.features.status': '💬 Presence status (Online, Idle, Do Not Disturb, etc.)',
                'help.features.statusCustom': '💬 Custom statuses with emoji and personalized message',
                'help.features.contacts': '👥 Complete contact list with pinned favorites on top and block management from the Users modal',
                'help.features.contactsMobile': '📱 Optimized mobile view with status and appearance on the top bar (same as desktop)',
                'help.features.contactsFilter': '👁️ Button to show/hide non-favorite contacts - reduces the list to only your favorites',
                'help.features.contactAlias': '✏️ Custom alias and private notes for each contact - click on the contact name in the conversation',
                'help.features.themes': '🎨 Two themes available: Argentina (light blue/white/gold) and Dark (deep purple)',
                'help.features.messages': '📨 Real-time messaging with read indicators, inline OpenMoji emojis and visible typing indicator',
                'help.features.attachments': '📎 Attach files compatible with written communication: images, videos, and PDF documents',
                'help.features.camera': '📸 Photo capture with front, back camera or webcam',
                'help.features.gallery': '🖼️ File selection from gallery',
                'help.features.compression': '🗜️ Automatic image compression and thumbnail generation',
                'help.features.progress': '📊 Progress bar during file upload',
                'help.features.delete': '🗑️ Deletion of your own messages',
                'help.features.scroll': '⬇️ Automatic scroll to last message when opening conversation',
                'help.features.profile': '👤 Customizable profile with avatar, biography, and preferences',
                'help.features.profileEdit': '✏️ Profile editing without interruptions (no refresh while editing)',
                'help.features.countries': '🌍 Complete list of 195+ countries with automatic time zone selection',
                'help.features.registration': '📧 Registration with mandatory Terms & Conditions before creating the account and email confirmation',
                'help.features.multilanguage': '🗣️ Support for {count} languages with flags; T&C and emails translated to the chosen language',
                'help.features.pwa': '📲 Installable PWA application on mobile devices and desktop',
                'help.features.sync': '🔄 Automatic message synchronization every 5 seconds',
                'help.features.deleteSync': '🗑️ Automatic synchronization of deleted messages across devices',
                'help.features.notifications': '🔔 Sound notifications for new received messages',
                'help.features.retranslation': '🔄 Automatic re-translation of messages if the first attempt fails',
                'help.features.preview': '👁️ File preview before sending',
                'help.features.security': '🔒 Security system with CAPTCHA, browser fingerprinting, rate limiting and mandatory T&C flow',
                'help.features.passwordRecovery': '🔑 Password recovery by email',
                'help.features.emailConfirmation': '📧 Account confirmation by email with activation link',
                'help.features.invitations': '📧 Private email invitations - Invite external contacts with defined language and context',
                'help.features.invitationsManagement': '📋 Complete invitation management - List, resend or cancel pending invitations from the menu',
                'help.features.contactStatus': '🏷️ Visible contact status - See the status of each contact (pending, registered, ready to chat)',
                'help.features.favorites': '⭐ Favorites system - Mark contacts as favorites for quick access',
                'help.features.profilePhoto': '📸 Improved profile photo upload - Select images from gallery with immediate preview',
                'help.features.translationSender': '👁️ Translation view for sender - See how your message was translated to the recipient\'s language',
                'help.features.unifiedContacts': '🔗 Unified contact model - Contacts are derived from invitations and existing conversations',
                'help.features.privacy': '🔒 Private mode by default - Your profile is private and only accessible through direct invitation',
                'help.features.export': '💾 Conversation export - Export complete conversations to PDF or HTML with images and files',
                'help.tips.title': 'Useful tips',
                'help.tips.language': '✅ Set your language with the {count}-flag selector; T&C and emails follow that language',
                'help.tips.status': '✅ Update your presence status so others know your availability',
                'help.tips.statusCustom': '✅ Create custom statuses with emoji and message to express your current state',
                'help.tips.search': '✅ Pin favorites (star) and block users from the "Users" modal',
                'help.tips.contactsFilter': '✅ Use the eye button (👁️) in the top bar to show or hide contacts that are not favorites',
                'help.tips.contactAlias': '✅ Click on the contact name in the conversation to add a custom alias and private notes',
                'help.tips.avatar': '✅ Click on a contact\'s avatar to see their image in large size',
                'help.tips.messages': '✅ The ArChat® icon blinks on unread messages; insert emojis with the OpenMoji picker',
                'help.tips.attachments': '✅ Attach images, videos, or PDFs with the clip (📎); compatible with written communication',
                'help.tips.camera': '✅ Use the camera to capture photos directly from the app',
                'help.tips.compression': '✅ Images are automatically compressed to save space',
                'help.tips.delete': '✅ You can delete your own messages by clicking the delete button',
                'help.tips.profile': '✅ Edit your profile without refresh and switch Argentina / Dark (light or dark theme).',
                'help.tips.themes': '✅ Change theme from Settings > Appearance: Argentina (light blue) or Dark (deep purple)',
                'help.tips.country': '✅ Select your country in the profile so the time zone is automatically configured',
                'help.message_time_context.title': 'Message time context',
                'help.message_time_context.description': 'Each message can store the sender\'s local time, timezone, and country at send time. You can see where and when the other user sent the message.',
                'help.message_time_context.point1': 'On FREE plan only the time in your timezone (receiver) is shown.',
                'help.message_time_context.point2': 'On PRO plan the sender\'s local time, country, and timezone are also shown.',
                'help.message_time_context.point3': 'Context is stored historically with each message.',
                'help.message_time_context.point4': 'Advanced audit features are available on higher plans.',
                'help.tips.registration': '✅ Before registering, accept T&C in your language; then verify your email to activate',
                'help.tips.writing': '✅ Write clear messages: ArChat® translates the meaning of written text, maintaining context and clarity',
                'help.tips.install': '✅ Install ArChat® as a PWA application on your device for quick access from the desktop',
                'help.tips.sync': '✅ Messages are automatically synchronized every 5 seconds - you don\'t need to refresh',
                'help.tips.deleteSync': '✅ If you delete a message, it will be automatically deleted on all recipient devices',
                'help.tips.notifications': '✅ You will hear a sound when you receive a new message from another user',
                'help.tips.retranslation': '✅ If a message was not translated correctly, the system will try to re-translate it automatically',
                'help.tips.preview': '✅ Review the file preview before sending to make sure it\'s the correct one',
                'help.tips.passwordRecovery': '✅ If you forgot your password, use the "Forgot your password?" link on the login',
                'help.tips.emailConfirmation': '✅ Check your email after registering and click on the confirmation link',
                'help.tips.languageChange': '✅ Change language from the flag selector: T&C, emails and UI update instantly',
                'help.tips.inputFixed': '✅ On PC, the writing bar stays fixed at the bottom of the screen for greater comfort',
                'help.tips.invitations': '✅ Invite contacts by email from your profile - Define language and conversation mode from the start',
                'help.tips.invitationsManagement': '✅ Manage your invitations from the "Sent Invitations" menu - Resend emails or cancel pending invitations',
                'help.tips.contactStatus': '✅ Observe the status of each contact in the list - Pending (orange), Registered (green) or Active conversation (blue)',
                'help.tips.favorites': '✅ Mark contacts as favorites with the star ⭐ - Favorites appear first in your list',
                'help.tips.profilePhoto': '✅ Upload your profile photo from "Choose from gallery" - You\'ll see a preview before saving',
                'help.tips.translationSender': '✅ When sending a message, expand the translation panel to see how it was translated to the recipient\'s language',
                'help.tips.unifiedContacts': '✅ Your contacts are automatically shown when they accept invitations or you have conversations with them',
                'help.tips.privacy': '✅ Your profile is private by default - Enable public visibility in Profile > Privacy if you want others to find you',
                'help.tips.export': '✅ Export complete conversations using the ⬇️ button in the header - Choose PDF or HTML with all images',
                'help.support.title': 'Support',
                'help.support.description': 'If you have problems or questions, contact the system administrator or review the available technical documentation.',
                'help.about.title': 'About',
                'help.about.developer': 'Developed by:',
                'help.about.location': 'MDQ - ARGENTINA',
                'help.about.linkedin': 'View LinkedIn profile',
                'presence.title': 'Presence Status',
                'presence.currentStatus': 'Current status:',
                'presence.changeStatus': 'Change status',
                'presence.status.online': 'Online',
                'presence.status.online.title': 'Online - Visible to everyone',
                'presence.status.online.description': 'Online: Visible to all contacts',
                'presence.status.idle': 'Idle',
                'presence.status.idle.title': 'Idle - Indicates temporary absence',
                'presence.status.idle.description': 'Idle: Indicates you are temporarily unavailable',
                'presence.status.dnd': 'Do Not Disturb',
                'presence.status.dnd.title': 'Do Not Disturb - Indicates you prefer not to be interrupted',
                'presence.status.dnd.description': 'Do Not Disturb: Visible signal that you prefer not to be interrupted',
                'presence.status.busy': 'Busy',
                'presence.status.busy.title': 'Busy - Not available',
                'presence.status.busy.description': 'Busy: Not available',
                'presence.status.offline': 'Offline',
                'presence.status.offline.title': 'Disconnected - Appear offline',
                'presence.status.offline.description': 'Offline: Appear disconnected',
                'presence.status.custom': 'Custom',
                'presence.status.custom.title': 'Custom - Unique status with emoji',
                'presence.status.custom.description': 'Custom: Unique status with emoji and optional expiration',
                'presence.custom.title': 'Custom Status',
                'presence.custom.status': 'Custom status',
                'presence.custom.placeholder': 'E.g: Having coffee ☕',
                'presence.custom.emoji': 'Emoji (optional)',
                'presence.custom.emojiHelp': 'Select an emoji or type one',
                'presence.custom.temporary': 'Temporary status (expires automatically)',
                'presence.custom.expiration': 'Expiration date',
                'presence.custom.expirationHelp': 'Status will return to "Online" when it expires',
                'presence.custom.suggestions': 'Suggestions',
                'presence.custom.preview': 'Preview',
                'presence.custom.save': 'Save Status',
                'presence.custom.required': 'Custom status is required',
                'presence.custom.maxLength': 'Maximum 64 characters',
                'presence.custom.expirationRequired': 'You must select an expiration date',
                'presence.custom.expirationFuture': 'Expiration date must be in the future',
                'presence.custom.selectEmoji': 'Select emoji',
                'presence.custom.suggestion.coffee': 'Having coffee ☕',
                'presence.custom.suggestion.soccer': 'At the soccer field ⚽',
                'presence.custom.suggestion.working': 'Heads down working 💪',
                'presence.custom.suggestion.lunch': 'Having lunch 🍽️',
                'presence.custom.suggestion.family': 'Family lunch 👨‍👩‍👧‍👦',
                'presence.custom.suggestion.studying': 'Studying 📚',
                'presence.custom.suggestion.travel': 'Traveling ✈️',
                'presence.custom.suggestion.meeting': 'In a meeting 💼',
                'presence.custom.suggestion.resting': 'Resting 😴',
                'presence.custom.suggestion.gaming': 'Playing videogames 🎮',
                'presence.custom.suggestion.reading': 'Reading 📖',
                'presence.custom.suggestion.offlineSoon': 'Back soon ⏳',
                'export.title': 'Export Conversation',
                'export.description': 'Select the format in which you want to export this conversation:',
                'export.progress': 'Exporting...',
                'export.format.pdf': 'PDF',
                'export.format.pdf.description': 'PDF document with all images and files',
                'export.format.html': 'HTML',
                'export.format.html.description': 'HTML file that you can open in any browser',
                'export.info': 'The export will include all messages, images and files from this conversation.',
                'export.pro_required.title': 'Export conversation',
                'export.pro_required.message': 'This feature is available on the PRO plan.',
                'invitation.title': 'Invite Contact by Email',
                'invitation.modal.title': 'Send Invitation',
                'invitation.modal.description': 'Invite someone to chat with you on ArChat®. They will receive an email with a link to accept the invitation.',
                'invitation.email.label': 'Invitee Email',
                'invitation.email.placeholder': 'example@email.com',
                'invitation.email.required': 'Email is required',
                'invitation.email.invalid': 'Please enter a valid email',
                'invitation.language.label': 'Invitee Preferred Language',
                'invitation.language.help': 'The email will be sent in this language',
                'invitation.mode.label': 'Conversation Mode',
                'invitation.mode.profesional': 'Professional',
                'invitation.mode.profesional.description': 'Formal and professional conversation',
                'invitation.mode.tecnico': 'Technical',
                'invitation.mode.tecnico.description': 'Technical and specialized conversation',
                'invitation.mode.casual': 'Casual',
                'invitation.mode.casual.description': 'Informal and friendly conversation',
                'invitation.message.label': 'Personal Message (optional)',
                'invitation.message.placeholder': 'Write a personal message for the invitee...',
                'invitation.send': 'Send Invitation',
                'invitation.sending': 'Sending...',
                'invitation.success': 'Invitation sent successfully',
                'invitation.success.title': 'Invitation Sent',
                'invitation.success.message': 'Invitation sent successfully.\n\nThe contact will receive an email with a link to accept the invitation. Once accepted, you can start chatting with them.',
                'invitation.error': 'Error sending invitation',
                'invitation.error.self': 'You cannot invite yourself',
                'invitation.error.duplicate': 'A pending invitation already exists for this email',
                'invitation.list.title': 'Sent Invitations',
                'invitation.top.title': 'Top Network Builders',
                'invitation.top.invitesSuffix': 'invites',
                'invitation.safe.phase_notice': 'Safe phase active: benefits pending commercial activation (no real impact on limits).',
                'invitation.safe.generate_code': 'Generate link/code',
                'invitation.safe.refresh_top3': 'Refresh Top 3',
                'invitation.safe.top_loading': 'Loading top inviters...',
                'invitation.safe.top_empty': 'No featured inviters yet.',
                'invitation.safe.hide_full_ranking': 'Hide full ranking',
                'invitation.safe.view_full_ranking': 'View full ranking',
                'invitation.safe.hide_metrics_dashboard': 'Hide metrics dashboard',
                'invitation.safe.view_metrics_dashboard': 'View metrics dashboard',
                'invitation.safe.prepared_link': 'Prepared link',
                'invitation.safe.email_placeholder': 'email@domain.com',
                'invitation.safe.register_pending': 'Register pending invitation',
                'invitation.safe.status_summary': 'Status summary',
                'invitation.safe.summary.pending': 'Pending',
                'invitation.safe.summary.registered': 'Registered',
                'invitation.safe.summary.active': 'Active',
                'invitation.safe.summary.validated': 'Validated',
                'invitation.safe.summary.rejected': 'Rejected',
                'invitation.safe.sent_invitations': 'Sent invitations',
                'invitation.safe.table.id': 'ID',
                'invitation.safe.table.invited_email': 'Invited email',
                'invitation.safe.table.code': 'Code',
                'invitation.safe.table.status': 'Status',
                'invitation.safe.table.created': 'Created',
                'invitation.safe.empty_sent': 'No sent invitations yet.',
                'invitation.safe.simulated_rewards': 'Earned simulated rewards',
                'invitation.safe.empty_rewards': 'No simulated rewards for now.',
                'invitation.safe.error.load_status': 'Could not load invitation status.',
                'invitation.safe.error.generate_code': 'Could not generate the code.',
                'invitation.safe.error.invalid_email': 'Enter a valid email to register the invitation.',
                'invitation.safe.error.register_pending': 'Could not register the pending invitation.',
                'invitation.safe.success.code_generated': 'Code generated successfully.',
                'invitation.safe.success.pending_registered': 'Pending invitation registered in safe mode.',
                'invitation.ranking.position': 'Position',
                'invitation.ranking.user': 'User',
                'invitation.ranking.validatedInvites': 'Validated invites',
                'invitation.ranking.empty': 'There are no validated invitations to display.',
                'invitation.ranking.loading': 'Loading ranking...',
                'invitation.ranking.loadError': 'Could not load ranking.',
                'invitation.list.empty': 'You haven\'t sent any invitations',
                'invitation.list.email': 'Email',
                'invitation.list.language': 'Language',
                'invitation.list.mode': 'Mode',
                'invitation.list.status': 'Status',
                'invitation.list.created': 'Sent',
                'invitation.list.expires': 'Expires',
                'invitation.list.actions': 'Actions',
                'invitation.status.pending': 'Pending',
                'invitation.status.accepted': 'Accepted',
                'invitation.status.expired': 'Expired',
                'invitation.status.cancelled': 'Cancelled',
                'invitation.status.deleted': 'Deleted',
                'invitation.deleted.tooltip': 'This invitation was deleted',
                'invitation.status.rejected': 'Rejected',
                'invitation.status.bounced': 'Bounced',
                'invitation.status.unknown': 'Unknown',
                'invitation.copy.link': 'Copy Link',
                'invitation.copy.success': 'Link copied to clipboard',
                'invitation.cancel': 'Cancel',
                'invitation.cancel.confirm': 'Are you sure you want to cancel this invitation?',
                'invitation.cancel.success': 'Invitation cancelled successfully',
                'invitation.cancel.title': 'Confirm Cancellation',
                'invitation.resend': 'Resend email',
                'invitation.resend.title': 'Resend Invitation',
                'invitation.resend.success': 'Invitation email resent successfully',
                'invitation.resend.error': 'Error resending invitation email',
                'invitation.accept.title': 'Accept Invitation',
                'invitation.accept.description': 'You have been invited to chat on ArChat®',
                'invitation.accept.inviter': 'Invited by',
                'invitation.accept.message': 'Personal message',
                'invitation.accept.login': 'Sign In',
                'invitation.accept.register': 'Register',
                'invitation.accept.error.invalid': 'Invalid invitation token',
                'invitation.accept.error.expired': 'This invitation has expired',
                'invitation.accept.error.accepted': 'This invitation has already been accepted',
                'invitation.accept.error.cancelled': 'This invitation was cancelled',
                'invitation.accept.error.email_mismatch': 'Your account email does not match the invitation email',
                'invitation.accept.success': 'Invitation accepted. Redirecting to chat...',
                'invitations.sent.title': 'Sent invitations',
                'invitations.sent.empty': 'No pending invitations',
                'invitations.pending.title': 'Pending invitations',
                'invitations.columns.email': 'Email',
                'invitations.columns.language': 'Language',
                'invitations.columns.mode': 'Mode',
                'invitations.columns.status': 'Status',
                'invitations.columns.sentAt': 'Sent',
                'invitations.columns.actions': 'Actions',
                'invitations.status.pending': 'Pending',
                'invitations.status.accepted': 'Accepted',
                'invitations.status.cancelled': 'Cancelled',
                'invitations.status.expired': 'Expired',
                'invitations.actions.cancel': 'Cancel',
                'invitations.actions.copy': 'Copy link',
                'invitations.actions.resend': 'Resend email',
                'invitations.waitBeforeResend': 'You cannot resend the invitation yet. You must wait 10 minutes between each send to avoid spamming the invited user.',
                'invitations.captchaQuestion': 'What is %1 + %2?',
                'invitations.resendSuccess': 'The invitation was resent successfully.',
                'invitations.dailyLimit': 'You have reached the maximum number of resends allowed today.',
                'invitations.invalidEmail': 'The mail server reported that this address is invalid.',
                'profile.privacy.title': 'Privacy',
                'profile.privacy.public_visibility': 'Make my profile publicly visible',
                'profile.privacy.public_warning': 'This allows any ArChat® user to find you and start a conversation.',
                'profile.privacy.private_info': 'Your profile is private. Only users you invite or who invite you can chat with you.',
                'profile.privacy.private_default': 'By default, your profile is private for greater security.',
                'common.close': 'Close',
                'common.cancel': 'Cancel',
                'common.confirm': 'Confirm',
                'common.save': 'Save',
                'common.saving': 'Saving...',
                'buttons.accept': 'Accept',
                'buttons.cancel': 'Cancel',
                'buttons.save': 'Save',
                'buttons.edit': 'Edit',
                'buttons.retry': 'Retry',
                'buttons.confirm': 'Confirm',
                'buttons.yes': 'Yes',
                'buttons.no': 'No',
                'buttons.send': 'Send',
                'buttons.close': 'Close',
                'buttons.continue': 'Continue',
                'buttons.delete': 'Delete',
                'buttons.logout': 'Log out',
                'buttons.back': 'Back',
                'buttons.update': 'Update',
                'buttons.upload': 'Upload',
                'buttons.select': 'Select',
                'achievement.unlocked': 'Achievement unlocked',
                'achievement.continue': 'Continue',
                'contact.edit.info.personalized': 'These changes are personalized only for you and do not affect other users.',
                'contact.edit.profileInfo': 'Profile Information',
                'dashboard.title': 'Dashboard',
                'dashboard.planUsage': 'Plan usage',
                'dashboard.filesSummary': 'My files',
                'dashboard.promotions': 'Promotions',
                'dashboard.sessions': 'Active sessions',
                'dashboard.explore': 'Explore',
                'dashboard.noSessions': 'No active sessions',
                'dashboard.welcomeTitle': 'Welcome to ArChat®',
                'dashboard.welcomeSubtitle': 'Chat in any language, seamlessly.',
                'dashboard.stepInvite': 'Step 1: invite your first contact',
                'dashboard.stepMessage': 'Step 2: send your first message',
                'dashboard.inviteContact': 'Invite a contact',
                'dashboard.exploreArChat': 'Explore ArChat',
                'dashboard.promotionsTitle': 'Promotions',
                'dashboard.promotionsText': 'Overview of the referral and rewards program.',
                'dashboard.viewPromotions': 'View promotions',
                'dashboard.usageTitle': 'Plan usage',
                'dashboard.sessionsTitle': 'Active sessions',
                'dashboard.sessionsEmpty': 'No active sessions',
                'dashboard.filesTitle': 'My files',
                'dashboard.viewFiles': 'View my files',
                'dashboard.noBlocks': 'No blocks are enabled. Turn on at least one in Settings.',
                'dashboard.openSettings': 'Open settings',
                'dashboard.goToContacts': 'Go to contacts',
                'dashboard.recentInbound.title': 'Latest messages received',
                'dashboard.recentInbound.empty': 'No recent messages received.',
                'dashboard.recentInbound.error': 'Could not load messages.',
                'dashboard.recentInbound.previewPhoto': 'Photo',
                'dashboard.recentInbound.previewFile': 'File',
                'dashboard.recentInbound.previewPdf': 'PDF',
                'dashboard.recentInbound.previewUnavailable': 'Message unavailable',
                'dashboard.recentInbound.readTitle': 'Read',
                'dashboard.recentInbound.unreadTitle': 'Unread',
                'dashboard.recentConversations.title': 'Recent conversations',
                'dashboard.recentConversations.empty': 'No conversations to show.',
                'dashboard.recentConversations.error': 'Could not load conversations.',
                'dashboard.filesVisible': 'Visible files',
                'dashboard.filesSampleNote': 'File count is from the first page of results (up to 500+).',
                'dashboard.loading': 'Loading data...',
                'dashboard.error.title': 'Error',
                'dashboard.error.load': 'Could not load usage data',
                'dashboard.error.generic': 'Error loading dashboard',
                'dashboard.error.no_data': 'Could not load data',
                'dashboard.retry': 'Retry',
                'dashboard.unlimited': 'Unlimited',
                'dashboard.not_available': 'Not available',
                'dashboard.plan.free': 'FREE',
                'dashboard.plan.foundation': 'FOUNDATION',
                'dashboard.plan.pro': 'PRO',
                'dashboard.plan.enterprise': 'ENTERPRISE',
                'dashboard.card.contacts': 'Contacts',
                'dashboard.card.chars': 'Characters',
                'dashboard.card.chars_month': 'Characters this month',
                'dashboard.card.storage': 'Storage',
                'dashboard.card.devices': 'Active devices',
                'dashboard.contacts': 'Contacts',
                'dashboard.characters': 'Characters',
                'dashboard.storage': 'Storage',
                'dashboard.active_devices': 'Active devices',
                'dashboard.need_more_resources': 'Need more resources?',
                'dashboard.upgrade_message': 'Upgrade your plan (FOUNDATION or PRO) to get more contacts, characters, storage and active devices.',
                'dashboard.upgrade_button': 'To plan PRO',
                'dashboard.upgrade_button_pro': 'Upgrade to PRO',
                'dashboard.upgrade_button_foundation': 'Upgrade to FOUNDATION',
                'dashboard.admin.title': 'Growth metrics',
                'dashboard.admin.newUsersToday': 'New users today',
                'dashboard.admin.messagesSentToday': 'Messages sent today',
                'dashboard.admin.translationsUsed': 'Translations used',
                'dashboard.admin.invitesCreated': 'Invites created',
                'dashboard.admin.invitesValidated': 'Invites validated',
                'dashboard.admin.inviteConversion': 'Invite conversion',
                'dashboard.admin.kFactor': 'K-Factor',
                'dashboard.admin.newUsers': 'New users',
                'dashboard.admin.messagesSent': 'Messages sent',
                'dashboard.admin.noData': 'No data',
                'dashboard.admin.kFactor.viral': 'Viral',
                'dashboard.admin.kFactor.stable': 'Stable',
                'dashboard.admin.kFactor.low': 'Low',
                'dashboard.admin.emailMetrics': 'Email metrics',
                'dashboard.admin.email.sent': 'Sent',
                'dashboard.admin.email.delivered': 'Delivered',
                'dashboard.admin.email.opened': 'Opened',
                'dashboard.admin.email.clicked': 'Clicked',
                'dashboard.admin.email.bounced': 'Bounced',
                'dashboard.admin.email.deliveryRate': 'Delivery rate',
                'dashboard.admin.email.openRate': 'Open rate',
                'dashboard.admin.email.bounceRate': 'Bounce rate',
                'dashboard.admin.funnelMetrics': 'Funnel metrics',
                'dashboard.admin.funnel.registered': 'Registered',
                'dashboard.admin.funnel.confirmed': 'Confirmed',
                'dashboard.admin.funnel.loggedIn': 'First login',
                'dashboard.admin.funnel.firstMessage': 'First message',
                'dashboard.admin.funnel.abandoned': 'Abandoned',
                'dashboard.admin.funnel.conversionRate': 'Conversion rate',
                'dashboard.admin.funnel.activationRate': 'Activation rate',
                'dashboard.admin.funnel.dropoffRate': 'Dropoff rate',
                'dashboard.admin.loading': 'Loading metrics...',
                'dashboard.admin.errorLoad': 'Could not load metrics dashboard.',
                'dashboard.admin.growthViral': 'Viral growth',
                'dashboard.admin.growthStable': 'Stable growth',
                'dashboard.admin.growthLow': 'Low growth',
                'dashboard.upgrade.title': 'Need more resources?',
                'dashboard.upgrade.message': 'Upgrade your plan (FOUNDATION or PRO) to get more contacts, characters, storage and active devices.',
                'dashboard.upgrade.button': 'Upgrade Plan',
                'upgrade.title': 'Upgrade Plan',
                'upgrade.close': 'Close',
                'upgrade.cancel': 'Cancel',
                'upgrade.activate': 'Activate PRO Plan',
                'upgrade.activating': 'Activating...',
                'upgrade.comparison.title': 'Plan Comparison',
                'upgrade.free.label': 'Free Plan',
                'upgrade.free.limits.contacts': '2 contacts maximum',
                'upgrade.free.limits.conversations': '2 conversations maximum',
                'upgrade.free.limits.no_export': 'No data export',
                'upgrade.free.limits.no_advanced': 'No advanced features',
                'upgrade.pro.label': 'Pro Plan',
                'upgrade.pro.recommended': 'RECOMMENDED',
                'upgrade.pro.benefits.contacts': 'Up to 100 contacts per user',
                'upgrade.pro.benefits.contacts.desc': 'Premium limit per plan engine (PlanConstants)',
                'upgrade.pro.benefits.conversations': 'Unlimited conversations and chats (tenant)',
                'upgrade.pro.benefits.conversations.desc': 'Message caps: 1,667/day and 50,000/month (tenant)',
                'upgrade.pro.benefits.export': 'Conversation export',
                'upgrade.pro.benefits.export.desc': 'Export your conversations in multiple formats (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Advanced notifications',
                'upgrade.pro.benefits.notifications.desc': 'Custom notifications and advanced configuration',
                'upgrade.pro.benefits.translation': 'Automatic translation',
                'upgrade.pro.benefits.translation.desc': 'Included within premium plan limits',
                'upgrade.pro.benefits.files': 'File attachments',
                'upgrade.pro.benefits.files.desc': 'Up to 50 MB storage (tenant), per plan policy',
                'upgrade.pro.benefits.themes': 'Custom themes',
                'upgrade.pro.benefits.themes.desc': 'Access to all themes and advanced customization',
                'upgrade.pro.benefits.security': 'Advanced security',
                'upgrade.pro.benefits.security.desc': 'Additional protection and enhanced privacy features',
                'upgrade.pro.benefits.analytics': 'Statistics and analytics',
                'upgrade.pro.benefits.analytics.desc': 'Access detailed statistics of your activity',
                'upgrade.pro.benefits.priority': 'Priority support',
                'upgrade.pro.benefits.priority.desc': 'Priority attention and quick response to your inquiries',
                'upgrade.enterprise.label': 'Enterprise Plan',
                'upgrade.enterprise.title': 'ENTERPRISE',
                'upgrade.enterprise.benefits.contacts': 'Unlimited contacts',
                'upgrade.enterprise.benefits.support': '24/7 priority support',
                'upgrade.enterprise.benefits.custom': 'Custom solutions',
                'upgrade.enterprise.benefits.advanced': 'Advanced enterprise features',
                'upgrade.enterprise.benefits.integration': 'Custom integrations',
                'upgrade.enterprise.benefits.dedicated': 'Dedicated support',
                'upgrade.success.title': 'PRO Plan Activated',
                'upgrade.success.message': 'Your plan has been updated to PRO. Enjoy all unlimited features.',
                'upgrade.error.title': 'Error Activating PRO',
                'upgrade.error.message': 'Could not update plan. Please try again.',
                'upgrade.error.generic': 'An unexpected error occurred. Please try again.',
                'upgrade.benefits.contacts': 'Up to 100 contacts per user',
                'upgrade.benefits.contacts.desc': 'Premium limit per plan engine (PlanConstants)',
                'upgrade.benefits.conversations': 'Unlimited conversations and chats (tenant)',
                'upgrade.benefits.conversations.desc': 'Message caps: 1,667/day and 50,000/month (tenant)',
                'upgrade.benefits.export': 'Conversation export',
                'upgrade.benefits.export.desc': 'Export your conversations in multiple formats (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Advanced notifications',
                'upgrade.benefits.notifications.desc': 'Custom notifications and advanced configuration',
                'upgrade.benefits.translation': 'Automatic translation',
                'upgrade.benefits.translation.desc': 'Included within premium plan limits',
                'upgrade.benefits.files': 'File attachments',
                'upgrade.benefits.files.desc': 'Up to 50 MB storage (tenant), per plan policy',
                'upgrade.benefits.themes': 'Custom themes',
                'upgrade.benefits.themes.desc': 'Access to all themes and advanced customization',
                'upgrade.benefits.security': 'Advanced security',
                'upgrade.benefits.security.desc': 'Additional protection and enhanced privacy features',
                'upgrade.benefits.analytics': 'Statistics and analytics',
                'upgrade.benefits.analytics.desc': 'Access detailed statistics of your activity',
                'upgrade.benefits.priority': 'Priority support',
                'upgrade.benefits.priority.desc': 'Priority attention and quick response to your inquiries',
                'upgrade.limits.contacts': '2 contacts maximum',
                'upgrade.limits.conversations': '2 conversations maximum',
                'upgrade.limits.no_export': 'No data export',
                'upgrade.limits.no_advanced': 'No advanced features',
                // API Error Messages
                'api.error.image_processing_not_available': 'Image processing is not available on the server',
                'api.error.image_functions_not_available': 'Image processing functions are not available',
                'api.error.method_not_allowed': 'Method not allowed',
                'api.error.user_not_identified': 'User not identified',
                'api.error.upload_file_too_large_php': 'File exceeds maximum size allowed by PHP',
                'api.error.upload_file_too_large_form': 'File exceeds maximum size allowed by the form',
                'api.error.upload_file_partial': 'File was partially uploaded',
                'api.error.upload_no_file': 'No file was uploaded',
                'api.error.upload_no_temp_dir': 'Temporary directory is missing',
                'api.error.upload_cant_write': 'Error writing file to disk',
                'api.error.upload_extension_stopped': 'A PHP extension stopped the upload',
                'api.error.upload_generic': 'File upload error',
                'api.error.file_type_not_allowed': 'File type not allowed. Only images are allowed (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'File is too large (max 10MB)',
                'api.error.storage_limit_exceeded': 'Storage limit exceeded. Upgrade your plan to upload more files.',
                'api.error.user_not_found': 'User not found or inactive',
                'api.error.image_directory_access': 'Error accessing image directory',
                'api.error.file_extension_not_allowed': 'File extension not allowed',
                'api.error.temp_file_save': 'Error saving temporary file',
                'api.error.image_processing': 'Error processing image',
                'api.error.database_update': 'Error updating database',
                'api.error.internal_server_error': 'Internal server error',
                'api.error.internal_server_error_debug': 'Internal server error',
                'api.error.user_id_required': 'User ID required',
                'api.error.profile_not_found': 'Profile not found',
                'api.error.profile_load_failed': 'Error loading profile',
                'api.error.invalid_data': 'Invalid data',
                'api.error.validation_errors': 'Validation errors',
                'api.error.profile_update_failed': 'Could not update profile',
                'api.error.profile_update_error': 'Error updating profile',
                // API Success Messages
                'api.success.photo_updated': 'Photo updated',
                'api.success.profile_loaded': 'Profile loaded successfully',
                'api.success.profile_updated': 'Profile updated successfully',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Device limit reached',
                'errors.deviceLimit.solution': 'To continue, log out from other devices or upgrade your plan.',
                // Error Messages - Network
                'errors.network.title': 'Connection error',
                'errors.network.message': 'Could not connect to the server. Check your internet connection.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Server error',
                'errors.server.invalidResponse.message': 'The server returned an invalid response. Please try again.',
                // Error Messages - Generic
                'errors.generic': 'An unexpected error occurred. Please try again.',
                'errors.modal.title': 'Error',
                'errors.modal.copyDetails': 'Copy details',
                'errors.modal.close': 'Close',
                'errors.modal.reportSupport': 'Report to support',
                'errors.modal.code': 'Code',
                'errors.modal.message': 'Message',
                'errors.modal.path': 'Path',
                'errors.modal.time': 'Time',
                'errors.modal.timestamp': 'Timestamp',
                'errors.modal.copied': 'Details copied',
                'errors.generic.title': 'Error',
                'errors.generic.message': 'An error occurred. Please try again.',
                'errors.network': 'Could not connect to the server. Check your connection.',
                'errors.unexpected': 'An unexpected error occurred. Please try again.',
                'errors.boundary.title': 'REACT ERROR CAPTURED',
                'errors.boundary.request_id': 'X-Request-ID:',
                'errors.boundary.correlate': 'Correlate with backend/logs/structured.log',
                'errors.boundary.message_label': 'Message:',
                'errors.boundary.stack_trace': 'Stack trace',
                'errors.boundary.component_stack': 'Component stack',
                'errors.boundary.empty': '(empty)',
                'errors.boundary.reload_page': 'Reload page',
                'errors.ui_boundary.refresh': 'ArChat UI error - refresh the page',
                'bootstrap.error.title': 'ArChat® - Startup error',
                'common.reload': 'Reload',
                'errors.avatarTooLarge': 'The image exceeds the maximum size of 2MB.',
                'errors.avatarTooLarge.title': 'Image too large',
                'errors.avatarTooLarge.message': 'The image exceeds the maximum size of 2MB.',
                'errors.invalidImageType': 'The selected file is not a valid image.',
                'errors.invalidImageType.title': 'Invalid file',
                'errors.invalidImageType.message': 'The selected file is not a valid image.',
                'errors.uploadFailed': 'The image upload failed. Please try again.',
                'errors.uploadFailed.title': 'Upload failed',
                'errors.uploadFailed.message': 'The image upload failed. Please try again.',
                'errors.conversationCreate': 'Error creating the conversation. Please try again.',
                'errors.conversationInvalidId': 'Invalid conversation ID.',
                'errors.conversationOpen': 'Error opening the conversation. Please try again.',
                'errors.favoriteUpdate': 'Could not update favorite',
                'errors.blockUpdate': 'Could not update block',
                'errors.messageEdit': 'Error editing the message.',
                'errors.generic.403.title': 'Access error',
                'errors.generic.403.message': 'You do not have permission to perform this action.',
                'errors.saas_max_users': 'Plan user limit reached ({current}/{limit}).',
                'errors.tenant_frozen': 'The tenant is temporarily blocked.',
                'errors.auth_invalid_credentials': 'Incorrect username or password.',
                'errors.foundation_sold_out': 'Founder slots are sold out.',
                'errors.unexpected_error': 'An unexpected error occurred. Please try again.',
                'errors.accountInactive.title': 'Account is inactive. Enter your email to reactivate it.',
                'errors.userInactive.title': 'Account deactivated',
                'errors.tenantMismatch.title': 'Tenant error',
                'errors.accountInactive.activate': 'Activate now',
                'errors.accountInactive.accept': 'Accept',
                'errors.accountInactive.success': 'Account reactivated. You can log in now.',
                'errors.accountInactive.fail': 'Could not reactivate account. Please try again.',
                'errors.accountInactive.completeSuccess': 'Account activated with your email. You can log in now.',
                'errors.accountInactive.completeFail': 'Could not complete activation. Check your email and try again.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Plan limit reached',
                'plan.errors.deviceLimit.message': 'Your current plan has a limit on the number of devices that can be connected simultaneously.',
                'plan.errors.deviceLimit.solution': 'To continue, log out from other devices or upgrade your plan to PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Contacts limit reached',
                'plan.errors.contactsLimit.message': 'Your current plan has a limit on the number of contacts you can have.',
                'plan.errors.contactsLimit.solution': 'To add more contacts, upgrade your plan to PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Invitations limit reached',
                'plan.errors.invitationsLimit.message': 'Your current plan has a limit on the number of invitations you can send per day.',
                'plan.errors.invitationsLimit.solution': 'To send more invitations, upgrade your plan to PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Messages limit reached',
                'plan.errors.messagesLimit.message': 'Your current plan has a limit on the number of messages you can send per day.',
                'plan.errors.messagesLimit.solution': 'To send more messages, upgrade your plan to PRO.',
                // Plan Errors - Translation
                'plan.errors.translationNotAllowed.title': 'Translation not available',
                'plan.errors.translationNotAllowed.message': 'Your current plan does not include automatic translation between languages.',
                'plan.errors.translationNotAllowed.solution': 'Upgrade your plan to use automatic translation.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Storage limit reached',
                'plan.errors.storageLimit.message': 'Your current plan has a limit on the amount of storage available.',
                'plan.errors.storageLimit.solution': 'To get more storage, upgrade your plan to PRO.',
                // Plan Errors - Chats/Conversations Limit
                'plan.errors.chatsLimit.title': 'Conversations limit reached',
                'plan.errors.chatsLimit.message': 'Your current plan has a limit on the number of conversations you can have.',
                'plan.errors.chatsLimit.solution': 'To create more conversations, upgrade your plan to PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Plan upgrade required',
                'plan.errors.upgradeRequired.message': 'This feature requires a higher plan than your current one.',
                'plan.errors.upgradeRequired.solution': 'Upgrade your plan to PRO to access this feature.',
                'appearance.theme.system': 'System',
                'appearance.theme.corporate': 'Corporate',
                'theme.system': 'System',
                'theme.corporate': 'Corporate',
                'founder.title': 'FOUNDATION (Founder)',
                'founder.subtitle': 'You support the project from the start with a lifetime price.',
                'founder.whatIs': 'The first 150 users get the FOUNDATION plan at a reduced lifetime price.',
                'founder.howItWorks': 'Your Founder level depends on your position (1 to 150).',
                'founder.benefitsTitle': 'Benefits',
                'founder.benefitPrice': '$15 / month (Founder rate)',
                'founder.benefitFeatures': 'Includes all PRO plan features.',
                'founder.limit': 'Only 150 Founder slots exist.',
                'founder.cancelRule': 'If you cancel, you lose Founder status while unsubscribed.',
                'founder.rejoinRule': 'If a slot becomes available again, you can reactivate and become a Founder again automatically.',
                'founder.tiers.title': 'Founder Levels',
                'founder.tiers.legendary.name': 'LEGENDARY Founder',
                'founder.tiers.legendary.range': 'Position 1–25',
                'founder.tiers.legendary.desc': 'The first to support the project. Highest historical priority.',
                'founder.tiers.early.name': 'EARLY Founder',
                'founder.tiers.early.range': 'Position 26–75',
                'founder.tiers.early.desc': 'Early support with special recognition.',
                'founder.tiers.founder.name': 'Founder',
                'founder.tiers.founder.range': 'Position 76–150',
                'founder.tiers.founder.desc': 'Founder slot within the 150 places.',
                'founder.whatIsLink': 'What is Founder?',
                'founder.viewTiers': 'View Founder levels',
                'founder.modalClose': 'Close',
                'founder.activeCountLabel': 'Active Founders',
                'founder.urgency.lastSlots': 'Last Founder slots available',
                'founder.positionLabel': 'Founder #{position} / {limit}',
                'founder.leaderboard.title': 'Top Founders',
                'auth.tagline': 'The power of being understood, no matter the language',
                'auth.sign_in': 'Sign In',
                'auth.create_account': 'Create account',
                'ui.search_contact': 'Search contact...',
                'ui.language': 'Language',
                'profile.my_profile': 'My Profile',
                'profile.status': 'Status',
                'profile.invite_email': 'Invite Contact by Email',
                'profile.sent_invitations': 'Sent Invitations',
                'profile.users': 'Users',
                'profile.settings': 'Settings',
                'profile.appearance': 'Appearance',
                'profile.logout': 'Logout',
                'contacts.mode': 'Mode',
                'contacts.sent': 'Sent',
                'contacts.actions': 'Actions',
                'contacts.pending': 'Pending',
                'contacts.available': 'Available',
                'contacts.invited_registered': 'Invited - Registered',
                'table.email': 'Email',
                'table.language': 'Language',
                'table.mode': 'Mode',
                'table.status': 'Status',
                'table.sent': 'Sent',
                'table.actions': 'Actions',
                'admin.access_denied.message': 'Message',
                'admin.access_denied.title': 'Title',
                'admin.action.change_plan': 'Change plan',
                'admin.action.reactivate': 'Reactivate',
                'admin.action.suspend': 'Suspend',
                'admin.action.view': 'View',
                'admin.confirm.change_plan.message': 'Message',
                'admin.confirm.change_plan.title': 'Title',
                'admin.confirm.suspend.message': 'Message',
                'admin.confirm.suspend.title': 'Title',
                'admin.details.created': 'Created',
                'admin.details.current_plan': 'Current plan',
                'admin.details.domain': 'Domain',
                'admin.details.last_activity': 'Last activity',
                'admin.details.name': 'Name',
                'admin.details.plan': 'Plan',
                'admin.details.status': 'Status',
                'admin.details.subscription': 'Subscription',
                'admin.details.tenant_id': 'Tenant id',
                'admin.details.tenant_info': 'Tenant info',
                'admin.details.usage': 'Usage',
                'admin.error.change_plan': 'Change plan',
                'admin.error.generic': 'Generic',
                'admin.error.load_details': 'Load details',
                'admin.error.load_tenants': 'Load tenants',
                'admin.error.reactivate': 'Reactivate',
                'admin.error.suspend': 'Suspend',
                'admin.error.title': 'Title',
                'admin.filter.active': 'Active',
                'admin.filter.all_plans': 'All plans',
                'admin.filter.all_status': 'All status',
                'admin.filter.suspended': 'Suspended',
                'admin.limit.devices': 'Devices',
                'admin.limit.invitations': 'Invitations',
                'admin.limit.messages': 'Messages',
                'admin.limit.storage': 'Storage',
                'admin.limit.users': 'Users',
                'admin.loading': 'Loading',
                'admin.no_tenants': 'No tenants',
                'admin.plan.enterprise': 'Enterprise',
                'admin.plan.free': 'Free',
                'admin.plan.pro': 'Pro',
                'admin.status.active': 'Active',
                'admin.status.suspended': 'Suspended',
                'admin.subscription.id': 'Subscription ref (external)',
                'admin.subscription.last_payment': 'Last payment',
                'admin.subscription.status': 'Status',
                'admin.subtitle': 'Subtitle',
                'admin.success.plan_changed': 'Plan changed',
                'admin.success.tenant_reactivated': 'Tenant reactivated',
                'admin.success.tenant_suspended': 'Tenant suspended',
                'admin.success.title': 'Title',
                'admin.table.actions': 'Actions',
                'admin.table.messages': 'Messages',
                'admin.table.name': 'Name',
                'admin.table.plan': 'Plan',
                'admin.table.status': 'Status',
                'admin.table.storage': 'Storage',
                'admin.table.tenant_id': 'Tenant id',
                'admin.table.users': 'Users',
                'admin.title': 'Title',
                'admin.usage.devices': 'Devices',
                'admin.usage.invitations': 'Invitations',
                'admin.usage.messages': 'Messages',
                'admin.usage.storage': 'Storage',
                'admin.usage.users': 'Users',
                'auth.login': 'Login',
                'auth.register': 'Register',
                'auth.reset_password': 'Reset password',
                'billing.cancel.button': 'Button',
                'billing.cancel.canceling': 'Canceling',
                'billing.cancel.confirm': 'Confirm',
                'billing.cancel.error': 'Error',
                'billing.cancel.success': 'Success',
                'billing.character_billing.characters_used': 'Characters used',
                'billing.character_billing.consumption_pct': 'Consumption pct',
                'billing.character_billing.days_remaining': 'Days remaining',
                'billing.character_billing.deletion_date': 'Deletion date',
                'billing.character_billing.period_start': 'Period start',
                'billing.character_billing.renewal_date': 'Renewal date',
                'billing.character_billing.title': 'Title',
                'billing.current_plan': 'Current plan',
                'billing.founder_badge': 'Founder badge',
                'billing.no_plans': 'No plans',
                'billing.subscription.canceled': 'Cancellation scheduled',
                'billing.subscription.canceled_note': 'Your subscription will cancel at the end of the current period. You can keep using your plan until then.',
                'billing.subscription.cancel_scheduled_date': 'Your subscription is scheduled to cancel on {{date}}. You can continue using your plan until then.',
                'billing.subscription.cancel_scheduled_badge': 'Cancels on {{date}}',
                'billing.scheduled.plan_after_cancel_label': 'Plan after period ends:',
                'billing.scheduled.plan_free': 'FREE',
                'billing.scheduled.plan_foundation': 'FOUNDATION',
                'billing.scheduled.switch_to_foundation': 'Switch to FOUNDATION',
                'billing.scheduled.switch_to_free': 'Switch to FREE',
                'billing.scheduled.foundation_full_title': 'FOUNDATION unavailable',
                'billing.scheduled.foundation_full_message': 'No FOUNDATION slots available right now. Your plan will downgrade to FREE at the end of the period.',
                'billing.scheduled.saving': 'Saving...',
                'billing.scheduled.error_title': 'Plan change error',
                'billing.scheduled.error_generic': 'Could not change the scheduled plan. Please try again.',
                'billing.cancel_scheduled.title': 'Scheduled cancellation',
                'billing.cancel_scheduled.desc': 'Your subscription will end on {{date}}. You can keep using your current plan until then.',
                'billing.cancel_scheduled.no_new_plan_until_end': 'Until this subscription ends you won\'t be able to purchase another plan.',
                'billing.cancel_scheduled.free_fallback': 'If you don\'t renew, your account will continue on FREE with the corresponding limitations.',
                'billing.cancel_scheduled.profile_deactivation_hint': 'You can also delete your account from your profile.',
                'billing.cancel_scheduled.default_free': 'After period ends: FREE',
                'billing.subscription.next_payment': 'Next payment',
                'billing.subscription.plan': 'Plan',
                'billing.subscription.price': 'Plan price',
                'billing.subscription.started': 'Started',
                'billing.subscription.status': 'Status',
                'billing.subscription.mp_flow.subscribe_failed': 'Could not start subscription. Please try again.',
                'billing.subscription.mp_flow.change_plan_failed': 'Could not change plan. Please try again.',
                'billing.subscription.mp_status.pending': 'Pending',
                'billing.subscription.mp_status.authorized': 'Authorized',
                'billing.subscription.mp_status.active': 'Active',
                'billing.subscription.mp_status.paused': 'Paused',
                'billing.subscription.mp_status.cancelled': 'Cancelled',
                'billing.subscription.mp_status.inactive': 'Inactive',
                'billing.subscription.mp_status.unknown': 'Unknown',
                'billing.unlimited': 'Unlimited',
                'billing.update_plan': 'Update plan',
                'billing.update_plan_modal.title': 'Title',
                'billing.usage.loading': 'Loading',
                'common.accept': 'Accept',
                'common.confirmPassword': 'ConfirmPassword',
                'common.continue': 'Continue',
                'common.error': 'Error',
                'dashboard.upgrade.to_plan': 'To plan',
                'emoji.noResults': 'NoResults',
                'emoji.pick': 'Pick',
                'export.restricted.message': 'Message',
                'export.restricted.title': 'Title',
                'export.restricted.upgrade': 'Upgrade',
                'founder.*': '*',
                'help.faq.a1': 'A1',
                'help.faq.a2': 'A2',
                'help.faq.a3': 'A3',
                'help.faq.a4': 'A4',
                'help.faq.a5': 'A5',
                'help.faq.a6': 'A6',
                'help.faq.a7': 'A7',
                'help.faq.q1': 'Q1',
                'help.faq.q2': 'Q2',
                'help.faq.q3': 'Q3',
                'help.faq.q4': 'Q4',
                'help.faq.q5': 'Q5',
                'help.faq.q6': 'Q6',
                'help.faq.q7': 'Q7',
                'help.faq.title': 'Title',
                'help.howWorks.step4.point7': 'Point7',
                'help.message_time_context.free_vs_pro': 'Free vs pro',
                'help.message_time_context.point5': 'Point5',
                'help.plans.enterprise.benefits': 'Benefits',
                'help.plans.enterprise.description': 'Description',
                'help.plans.enterprise.title': 'Title',
                'help.plans.foundation.devices': 'Devices',
                'help.plans.free.description': 'Description',
                'help.plans.free.devices': 'Devices',
                'help.plans.free.limits': 'Limits',
                'help.plans.free.title': 'Title',
                'help.plans.intro': 'Intro',
                'help.plans.pro.benefits': 'Benefits',
                'help.plans.pro.description': 'Description',
                'help.plans.pro.devices': 'Devices',
                'help.plans.pro.price': '$19 / month',
                'help.plans.pro.title': 'Title',
                'help.plans.pro.upgrade': 'Upgrade',
                'help.plans.title': 'Title',
                'help.plans.urgent_slots_badge': 'Urgent slots badge',
                'help.slogan.final': 'Final',
                'help.suggestions.point1': 'Point1',
                'help.suggestions.point2': 'Point2',
                'help.suggestions.title': 'Title',
                'invitation.already_contact_added': 'Already contact added',
                'invitation.already_contact_title': 'Already contact title',
                'invitation.already_pending': 'Already pending',
                'invitation.language.invalid': 'Invalid',
                'message.send': 'Send',
                'message.sendFile': 'SendFile',
                'messages.conversations': 'Conversations',
                'messages.no_conversations_subtitle': 'No conversations subtitle',
                'messages.no_conversations_title': 'No conversations title',
                'presence.custom.edit': 'Edit',
                'profile.enrichment.country': 'Country',
                'profile.enrichment.country.select': 'Select',
                'profile.enrichment.description': 'Description',
                'profile.enrichment.org_size': 'Org size',
                'profile.enrichment.org_size.placeholder': 'Placeholder',
                'profile.enrichment.save': 'Save',
                'profile.enrichment.skip': 'Skip',
                'profile.enrichment.title': 'Title',
                'profile.enrichment.usage_type.label': 'Label',
                'profile.enrichment.usage_type.placeholder': 'Placeholder',
                'profile.founderPosition': 'FounderPosition',
                'settings.confirmations.description': 'Description',
                'settings.confirmations.disable': 'Disable',
                'settings.confirmations.title': 'Title',
                'settings.confirmations.updated': 'Updated',
                'settings.title': 'Title',
                'theme.description': 'Description',
                'google.missing_client_id': 'Google sign-in is unavailable in this build: VITE_GOOGLE_CLIENT_ID is missing (or per-tenant googleClientId in __ARCHAT_TENANT_CONFIG__).',
                'google.unavailable_tenant': 'Google is unavailable for this tenant.',
                'google.unavailable': 'Google unavailable.',
                'google.verify_client_id': 'Verify the Client ID in Google Cloud Console.',
                'google.login_aria': 'Sign in with Google',
                'message.preview_alt': 'Preview',
                'message.image_attachment_alt': 'Attached image',
                'profile.avatar.alt': 'avatar',
                'plan.name.free': 'FREE',
                'plan.name.pro': 'PRO',
                'plan.name.foundation': 'FOUNDATION',
                'plan.name.enterprise': 'ENTERPRISE',
                'plan.pro_contacts': 'Up to 100 contacts per user',
                'register.emailPlaceholder': 'you@email.com',
                'login.prompt_create_account_with_name': 'Do you want to create an account with this name?',
                'invitation.top.loading': 'Loading top inviters...',
                'invitation.top.empty': 'No featured inviters yet.',
                'invitation.contacts.title': 'Invite contacts',
                'invitation.contacts.safe_phase_note': 'Safe phase active: pending benefits without impact on real limits.',
                'invitation.contacts.generate_code': 'Generate code/link',
                'invitation.contacts.refresh_top3': 'Refresh Top 3',
                'invitation.contacts.hide_full_ranking': 'Hide full ranking',
                'invitation.contacts.show_full_ranking': 'Show full ranking',
                'invitation.contacts.hide_metrics_dashboard': 'Hide metrics dashboard',
                'invitation.contacts.show_metrics_dashboard': 'Show metrics dashboard',
                'invitation.contacts.prepared_link_label': 'Prepared link:',
                'invitation.contacts.email_placeholder': 'email@domain.com',
                'invitation.contacts.register_pending': 'Register pending invitation',
                'invitation.contacts.status_summary': 'Status summary',
                'invitation.contacts.sent_invitations': 'Sent invitations',
                'invitation.contacts.invited_email': 'Invited email',
                'invitation.contacts.code': 'Code',
                'invitation.contacts.no_sent_invitations': 'No sent invitations yet.',
                'invitation.contacts.simulated_rewards': 'Simulated rewards obtained',
                'invitation.contacts.no_simulated_rewards': 'No simulated rewards yet.',
                'common.id': 'ID',
                'common.status': 'Status',
                'common.created': 'Created',

                'reviews.menu_title': 'Reviews',
                'reviews.rate_archat': 'Rate ArChat',
                'reviews.title': 'ArChat Reviews',
                'reviews.create_title': 'How would you rate ArChat?',
                'reviews.edit_title': 'Edit my review',
                'reviews.comment_placeholder': 'Tell us about your experience (optional)...',
                'reviews.submit_btn': 'Submit review',
                'reviews.update_btn': 'Update',
                'reviews.thank_you': 'Thanks for your review!',
                'reviews.submitted_message': 'Your feedback helps us improve.',
                'reviews.error_select_rating': 'Please select a rating',
                'reviews.error_generic': 'Error submitting review',
                'reviews.prompt_message': 'Enjoying ArChat? Leave a review!',
                'reviews.rate_now': 'Rate now',
                'reviews.later': 'Later',
                'reviews.write_review': 'Write a review',
                'reviews.edit_my_review': 'Edit my review',
                'reviews.my_review': 'My review',
                'reviews.no_reviews': 'No reviews yet. Be the first!',
                'reviews.review_singular': 'review',
                'reviews.review_plural': 'reviews',
                'reviews.verified': 'Verified',
                'reviews.anonymous': 'Anonymous',
                'files.storageUsed': 'Storage used',
                'files.planQuota': 'Plan quota',
                'files.availableStorage': 'Available',
                'files.usagePercent': 'used',
                'files.unlimited': 'Unlimited',
                'files.sentBy': 'Sent by',
                'files.unknownUser': 'User',
                'files.preview': 'Preview',
                'files.previewFile': 'File preview',
                'files.previewUnavailable': 'Preview is not available.',
                'files.previewLoading': 'Loading preview…',
                'files.openPreview': 'Preview',
                'files.downloadFile': 'Download file',
                'files.downloadFailed': 'The file could not be downloaded. Check your connection and session, then try again.',
                'files.closePreview': 'Close preview',
                'files.unsupportedPreview': 'No preview for this file type. You can review the details below or download the file.',
                'files.pdfPreviewHelp': 'This browser may not show the PDF inline. Use download to open it.',
                'files.labelFileType': 'Type',
                'files.previewForbidden': 'You do not have permission to preview this file.',
                'files.previewNotFound': 'The file is not available or is no longer visible in your account.',
                'settings.heading': "Settings",
                'settings.dashboard': 'Dashboard',
                'settings.dashboardDescription': 'Local preferences for the home panel layout and visible blocks.',
                'settings.dashboardGridHeading': 'Panel blocks',
                'settings.dashboardShowOnStartDescription': 'When on, the Dashboard opens after you sign in instead of the contact list.',
                'settings.dashboardBlockWelcome': 'Welcome',
                'settings.dashboardBlockUsage': 'Plan usage',
                'settings.dashboardBlockFiles': 'My files',
                'settings.dashboardBlockPromotions': 'Promotions',
                'settings.dashboardBlockSessions': 'Sessions',
                'settings.dashboardWelcomeDescription': 'Getting started, invite contact, and help shortcuts.',
                'settings.dashboardUsageDescription': 'Usage vs limits: contacts, characters, storage, and devices.',
                'settings.dashboardFilesDescription': 'Summary of visible files and storage from My files.',
                'settings.dashboardPromotionsDescription': 'Promotions summary and link to the program.',
                'settings.dashboardSessionsDescription': 'Active sessions and devices; you can close other sessions if available.',
                'settings.enabled': 'On',
                'settings.disabled': 'Off',
                'settings.showDashboardOnStart': 'Show dashboard on login',
                'settings.showWelcomeBlock': 'Show welcome & getting started',
                'settings.showPromotionsBlock': 'Show promotions block',
                'settings.showUsageBlock': 'Show plan usage',
                'settings.showRecentConversationsBlock': 'Show recent conversations (last message per contact)',
                'settings.showSessionsBlock': 'Show active sessions',
                'settings.showFilesBlock': 'Show my files summary',
                'settings.dashboardLocalNote': 'These preferences are stored in this browser (local) until a profile API is available.',
                'settings.appearanceSettings': "Appearance",
                'settings.argentinaTheme': "Argentina theme",
                'settings.darkMode': "Dark mode",
                'settings.language': "Language",
                'settings.messageSound': "Message sound",
                'settings.playSoundDescription': "Play a sound for new messages or important alerts.",
                'settings.webPushSection': 'System notifications (Web Push / PWA)',
                'settings.webPushDescription':
                  'Allows alerts when the app is in the background or closed on mobile. Requires VAPID public key in the build (VITE_VAPID_PUBLIC_KEY) and server keys. Grants browser permission and registers this device.',
                'settings.webPushButton': 'Enable push notifications',
                'settings.webPushRegistering': 'Registering…',
                'settings.webPushState.granted':
                  'Permission granted. If VAPID is configured, the subscription was sent to the server.',
                'settings.webPushState.denied':
                  'Permission denied. Enable notifications for this site in the browser settings.',
                'settings.webPushState.default': 'Tap the button to request permission and register this device.',
                'settings.webPushState.unsupported': 'This browser does not support Web Push.',
                'settings.webPushVapidMissing':
                  'VITE_VAPID_PUBLIC_KEY is missing in this frontend build: push subscription cannot complete.',
                'settings.messageSoundEnabled': "On",
                'settings.messageSoundDisabled': "Off",
                'settings.unreadEmailReminderSection': "Unread email digest",
                'settings.unreadEmailReminderDescription': "If you leave new messages or files unread longer than the wait time below, ArChat sends one grouped summary to your email (not one email per message).",
                'settings.unreadEmailReminderToggle': "Send me unread summaries by email",
                'settings.unreadEmailDelayHours': "Wait before sending (hours)",
                'settings.unreadEmailDelayHint': "1–168 hours (up to one week). The email uses your profile language.",
                'settings.accountSettings': "Account",
                'settings.deleteAccount': "Delete account",
                'settings.deleteAccountWarning': "This is permanent. Your data, messages, contacts, and settings will be removed according to the platform’s deletion process.",
                'settings.deleteMyAccount': "Delete my account",
                'subjects.title': 'Subjects',
                'subjects.singular': 'Subject',
                'subjects.plural': 'Subjects',
                'subjects.general': 'General',
                'subjects.new': 'New subject',
                'subjects.create': 'Create subject',
                'subjects.rename': 'Rename',
                'subjects.finish': 'Finish',
                'subjects.reopen': 'Reopen',
                'subjects.select': 'Continue',
                'subjects.status.open': 'Open',
                'subjects.status.pending': 'Pending',
                'subjects.status.finished': 'Finished',
                'subjects.limitReached': 'You reached the active subject limit for this conversation. Finish a subject to create another.',
                'subjects.limitReachedFree': 'Your FREE plan allows up to 3 active subjects per conversation. Finish a subject to create another.',
                'subjects.limitReachedPro': 'Your PRO plan allows up to 5 active subjects per conversation. Finish a subject to create another.',
                'subjects.limitReachedFoundation': 'Your FOUNDATION plan allows up to 5 active subjects per conversation. Finish a subject to create another.',
                'subjects.activeLimitsLine': 'Active subjects: {current} / {max}',
                'subjects.closedListTitle': 'Closed subjects',
                'subjects.viewClosed': 'View closed subjects',
                'subjects.noClosedSubjects': 'There are no closed subjects.',
                'subjects.reopenSubject': 'Reopen',
                'subjects.reopenedSubjects': 'Reopened subjects',
                'subjects.reopenLimitReached':
                  'You reached the active subject limit. Finish another subject to reopen this one.',
                'subjects.ownerOnlyReopen': 'Only the person who created this subject can reopen it.',
                'subjects.modal.title': 'Conversation subjects',
                'subjects.modal.subtitle': 'Choose or manage the subjects of this conversation.',
                'subjects.contactLabel': 'CONTACT:',
                'subjects.ownerOnlyRename': 'Only the person who created this subject can rename it.',
                'subjects.ownerOnlyStateChange': 'Only the person who created this subject can change its status.',
                'subjects.createdByOther': 'This subject was created by the other party. You can reply, but you cannot rename it.',
                'subjects.empty': 'No subjects to show.',
                'subjects.noResults': 'No subjects found.',
                'subjects.error.generic': 'We could not complete the action. Please try again.',
                'subjects.error.featureDisabled': 'Subjects are not available in this environment.',
                'subjects.error.duplicateName': 'An active subject with that name already exists.',
                'subjects.error.ownerRequired': 'You do not have permission to modify this subject.',
                'subjects.error.defaultCannotRename': 'The General subject cannot be renamed.',
                'subjects.error.defaultCannotFinish': 'The General subject cannot be finished.',
                'subjects.current': 'Subject',
                'subjects.change': 'Change subject',
                'subjects.currentLabel': 'Subject:',
                'subjects.changeSubject': 'Change subject',
                'subjects.closedCannotSend': 'This subject is finished. Reopen it to send new messages.',
                'subjects.selectBeforeSend': 'Choose a subject in the modal to view messages and send.',
                'subjects.loadingMessages': 'Loading messages for this subject…',
                'subjects.messageFilterError': 'We could not load messages for this subject.',
                'subjects.searchTitle': 'Search in subjects',
                'subjects.searchPlaceholder': 'Search in subjects...',
                'tags.etiquetas': 'tags',
                'tags.manageTitle': 'Manage tags',
                'tags.manage': '🏷️ Tags',
                'tags.allTags': 'All tags',
                'tags.confirmDelete': 'Delete this tag?',
                'tags.tagNamePlaceholder': 'Tag name',
                'tags.create': 'Create',
                'tags.noTags': 'No tags yet. Create one above.',
                'tags.save': 'Save',
                'tags.edit': 'Edit',
                'tags.delete': 'Delete',
                'tags.assignTo': 'Assign to',
                'tags.noTagsToAssign': 'No tags available. Create them first.',
                'tags.bgColor': 'Background color',
                'tags.textColor': 'Text color',
                'tags.selectTag': 'Select a tag',
                'templates.selectTitle': 'Templates',
                'templates.noTemplates': 'No templates yet. Create one above.',
                'templates.manage': 'Manage templates',
                'templates.confirmDelete': 'Delete this template?',
                'templates.manageTitle': 'Manage templates',
                'templates.titlePlaceholder': 'Template title',
                'templates.bodyPlaceholder': 'Write the template message...',
                'templates.create': 'Create template',
                'templates.save': 'Save',
                'templates.edit': 'Edit',
                'templates.delete': 'Delete',
                ...PRESET_LOCALES.en,
};
